// グローバルカート更新ロック（複数の同時更新を防ぐ）
window.cartUpdateQueue = window.cartUpdateQueue || {
  isLocked: false,
  pendingRequests: [],
  currentOperation: null, // 現在実行中の操作を追跡

  async executeWithLock(fn) {
    // ロックを待機（最大10秒）
    let waitTime = 0;
    const maxWaitTime = 10000; // 10秒

    while (this.isLocked && waitTime < maxWaitTime) {
      await new Promise(resolve => setTimeout(resolve, 100));
      waitTime += 100;
    }

    if (this.isLocked) {
      console.warn('Cart update lock timeout, forcing unlock');
      this.isLocked = false;
    }

    this.isLocked = true;
    this.currentOperation = { startTime: Date.now(), description: 'cart update' };

    try {
      const result = await fn();
      return result;
    } finally {
      this.isLocked = false;
      this.currentOperation = null;
      console.log('Cart update lock released');
    }
  }
};

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      // Shopifyの/cart/changeエンドポイント（セクション更新用）では、lineパラメータとしてitem.index（1ベース）を使用する必要がある
      const line = this.dataset.index; // item.index | plus: 1 を使用

      console.log('CartRemoveButton - index:', this.dataset.index, 'line:', line);

      cartItems.updateQuantity(line, 0, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');


    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    // 処理中フラグ
    this.isUpdating = false;
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    if (input) {
    input.value = input.getAttribute('value');
    }
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    // input要素の場合のみselect()を実行
    if (event.target.tagName === 'INPUT') {
    event.target.select();
    }
  }

  validateQuantity(event) {
    // event.targetが数量入力フィールドでない場合（ボタンクリック時など）、数量入力フィールドを探す
    let quantityInput = event.target;
    if (quantityInput.tagName !== 'INPUT' || !quantityInput.classList.contains('quantity__input')) {
      // ボタンがクリックされた場合、親要素から数量入力フィールドを探す
      const quantityInputElement = event.target.closest('quantity-input');
      if (quantityInputElement) {
        quantityInput = quantityInputElement.querySelector('.quantity__input');
      } else {
        // cart-items内の数量入力フィールドを探す
        const cartItem = event.target.closest('tr.cart-item, .cart-item');
        if (cartItem) {
          quantityInput = cartItem.querySelector('.quantity__input');
        }
      }
    }

    // 数量入力フィールドが見つからない場合は処理を中断
    if (!quantityInput || !quantityInput.classList.contains('quantity__input')) {
      console.warn('validateQuantity - quantity input not found, event.target:', event.target);
      return;
    }

    const inputValue = parseInt(quantityInput.value);
    const index = quantityInput.dataset.index; // item.index | plus: 1 (1ベースのインデックス)
    // Shopifyの/cart/changeエンドポイント（セクション更新用）では、lineパラメータとしてitem.index（1ベース）を使用する必要がある
    // item.keyは/cart/change.jsで使用するが、/cart/changeではitem.indexを使用
    const line = index; // item.index | plus: 1 を使用

    console.log('validateQuantity - inputValue:', inputValue, 'index:', index, 'line:', line, 'quantityInput:', quantityInput);

    let message = '';

    if (inputValue < quantityInput.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', quantityInput.dataset.min);
    } else if (inputValue > parseInt(quantityInput.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', quantityInput.max);
    } else if (inputValue % parseInt(quantityInput.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', quantityInput.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      quantityInput.setCustomValidity('');
      quantityInput.reportValidity();
      this.updateQuantity(
        line,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        quantityInput.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    // gift-wrapping-selectorの変更は除外（チェックアウト時に処理される）
    if (event.target.classList.contains('gift-wrapping-selector')) {
      return;
    }

    this.validateQuantity(event);
  }

  onCartUpdate() {
    // DOM更新前に、現在のギフトラッピングselectの値を保存（itemKeyとvariant_idの両方）
    const savedSelectValues = new Map(); // itemKeyベース
    const savedSelectValuesByVariantId = new Map(); // variant_idベース（国切り替え時の復元用）
    const currentSelects = document.querySelectorAll('.gift-wrapping-selector');
    currentSelects.forEach(select => {
      const itemKey = select.getAttribute('data-item-key');
      const variantId = select.getAttribute('data-variant-id');
      if (itemKey && select.value) {
        savedSelectValues.set(itemKey, select.value);
        console.log(`[onCartUpdate] Saved select value for ${itemKey}: ${select.value}`);
      }
      if (variantId && select.value) {
        savedSelectValuesByVariantId.set(variantId, select.value);
        console.log(`[onCartUpdate] Saved select value for variant_id ${variantId}: ${select.value}`);
      }
    });

    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }

          // DOM更新後、保存したselectの値を復元（itemKeyとvariant_idの両方で試行）
          if (savedSelectValues.size > 0 || savedSelectValuesByVariantId.size > 0) {
            setTimeout(() => {
              const updatedSelects = document.querySelectorAll('.gift-wrapping-selector');
              updatedSelects.forEach(select => {
                const itemKey = select.getAttribute('data-item-key');
                const variantId = select.getAttribute('data-variant-id');
                let valueToRestore = null;

                // 優先順位1: itemKeyで復元
                if (itemKey && savedSelectValues.has(itemKey)) {
                  valueToRestore = savedSelectValues.get(itemKey);
                  console.log(`[onCartUpdate] Restored select value for ${itemKey} from saved value (by itemKey): ${valueToRestore}`);
                }
                // 優先順位2: variant_idで復元（国切り替え時にitemKeyが変わった場合）
                else if (variantId && savedSelectValuesByVariantId.has(variantId)) {
                  valueToRestore = savedSelectValuesByVariantId.get(variantId);
                  console.log(`[onCartUpdate] Restored select value for variant_id ${variantId} from saved value (by variantId): ${valueToRestore}`);
                }

                if (valueToRestore) {
                  select.value = valueToRestore;
                }
              });
            }, 100);
          }

          // カウントも更新（onCartUpdateは頻繁に呼ばれるため、カートデータの取得を最小限にする）
          // 注意: onCartUpdateはShopifyのイベントで、カートの状態が変わる可能性があるため、
          // ここではカウント更新のみを行い、属性更新はrenderContentsに任せる
          setTimeout(() => {
            // cart-items要素から最新のカートデータを取得（既に取得済みの場合は再利用）
            const cartItemsElement = document.querySelector('cart-items');
            let cartData = null;
            if (cartItemsElement && cartItemsElement.lastCartData) {
              cartData = cartItemsElement.lastCartData;
              console.log('Reusing cartData from cart-items element in onCartUpdate');
            } else {
              // データがない場合のみ新規取得
              fetch('/cart.js')
                .then(response => response.json())
                .then(fetchedCartData => {
                  if (cartItemsElement) {
                    cartItemsElement.lastCartData = fetchedCartData;
                  }
                  updateCartCountFromData(fetchedCartData);
                })
                .catch(error => console.error('Error updating cart count in onCartUpdate:', error));
              return;
            }

            // 既にデータがある場合は即座に更新
            updateCartCountFromData(cartData);

            function updateCartCountFromData(cartData) {
              const itemCountExcludingGiftWrapping = window.calculateCartItemCountExcludingGiftWrapping
                ? window.calculateCartItemCountExcludingGiftWrapping(cartData)
                : cartData.item_count;

              // カートアイコンのカウントを更新（カートが空の場合は非表示）
              const cartIconBubbles = document.querySelectorAll('.cart-count-bubble');
              cartIconBubbles.forEach(bubble => {
                if (itemCountExcludingGiftWrapping > 0) {
                  const bubbleSpan = bubble.querySelector('span');
                  if (bubbleSpan) {
                    bubbleSpan.textContent = itemCountExcludingGiftWrapping;
                  }
                  bubble.style.display = '';
                } else {
                  bubble.style.display = 'none';
                }
              });

              // "Your Cart"の右隣のカウントも更新
              const cartItemsElement = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
              if (cartItemsElement && typeof cartItemsElement.updatePageHeadingCartCount === 'function') {
                cartItemsElement.updatePageHeadingCartCount(itemCountExcludingGiftWrapping);
              }
            }
          }, 150);
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;

          // DOM更新後、保存したselectの値を復元（itemKeyとvariant_idの両方で試行）
          if (savedSelectValues.size > 0 || savedSelectValuesByVariantId.size > 0) {
            setTimeout(() => {
              // カートAPIから最新の状態を取得して復元
              fetch('/cart.js')
                .then(response => response.json())
                .then(cartData => {
                  // カート属性からも復元を試行（国切り替え時の復元用）
                  let selectionsByVariantId = {};
                  if (cartData.attributes && cartData.attributes['Gift_Wrapping_Selections']) {
                    try {
                      const parsed = JSON.parse(cartData.attributes['Gift_Wrapping_Selections']);
                      if (parsed.byVariantId) {
                        selectionsByVariantId = parsed.byVariantId;
                      }
                    } catch (e) {
                      console.warn('[onCartUpdate] Error parsing Gift_Wrapping_Selections:', e);
                    }
                  }

                  const updatedSelects = document.querySelectorAll('.gift-wrapping-selector');
                  updatedSelects.forEach(select => {
                    const itemKey = select.getAttribute('data-item-key');
                    const variantId = select.getAttribute('data-variant-id');
                    let valueToRestore = null;

                    // 優先順位1: 保存した値（itemKey）
                    if (itemKey && savedSelectValues.has(itemKey)) {
                      valueToRestore = savedSelectValues.get(itemKey);
                      console.log(`[onCartUpdate] Restored select value for ${itemKey} from saved value (by itemKey): ${valueToRestore}`);
                    }
                    // 優先順位2: 保存した値（variant_id）
                    else if (variantId && savedSelectValuesByVariantId.has(variantId)) {
                      valueToRestore = savedSelectValuesByVariantId.get(variantId);
                      console.log(`[onCartUpdate] Restored select value for variant_id ${variantId} from saved value (by variantId): ${valueToRestore}`);
                    }
                    // 優先順位3: カート属性から復元（variant_id）
                    else if (variantId && selectionsByVariantId[variantId]) {
                      valueToRestore = selectionsByVariantId[variantId];
                      console.log(`[onCartUpdate] Restored select value for variant_id ${variantId} from cart attributes: ${valueToRestore}`);
                    }
                    // 優先順位4: カートAPIから復元（itemKey）
                    else if (itemKey && cartData.items && cartData.items.length > 0) {
                      const item = cartData.items.find(i => i.key === itemKey);
                      if (item && item.properties && item.properties['Gift_Wrapping']) {
                        const giftWrappingValue = item.properties['Gift_Wrapping'];
                        if (giftWrappingValue === 'gift' || giftWrappingValue === 'none') {
                          valueToRestore = giftWrappingValue;
                          console.log(`[onCartUpdate] Restored select value for ${itemKey} from cart API: ${giftWrappingValue}`);
                        }
                      }
                    }
                    // 優先順位5: カートAPIから復元（variant_id）
                    else if (variantId && cartData.items && cartData.items.length > 0) {
                      const item = cartData.items.find(i => String(i.variant_id) === String(variantId));
                      if (item && item.properties && item.properties['Gift_Wrapping']) {
                        const giftWrappingValue = item.properties['Gift_Wrapping'];
                        if (giftWrappingValue === 'gift' || giftWrappingValue === 'none') {
                          valueToRestore = giftWrappingValue;
                          console.log(`[onCartUpdate] Restored select value for variant_id ${variantId} from cart API: ${giftWrappingValue}`);
                        }
                      }
                    }

                    if (valueToRestore) {
                      select.value = valueToRestore;
                    }
                  });

                  // ギフトラッピングUIの状態も復元
                  const omakaseRadio = document.getElementById('omakase');
                  if (omakaseRadio && omakaseRadio.checked) {
                    const wrappingOptions = document.querySelectorAll('.wrapping-options');
                    wrappingOptions.forEach(opt => opt.style.display = 'block');
                    const cartWrappingBlock = document.querySelector('.cart-wrapping-item');
                    if (cartWrappingBlock) cartWrappingBlock.style.display = 'block';
                  }

                  // カウントも更新
                  const itemCountExcludingGiftWrapping = window.calculateCartItemCountExcludingGiftWrapping
                    ? window.calculateCartItemCountExcludingGiftWrapping(cartData)
                    : cartData.item_count;

                  // cart.attributesに件数を保存（全ページで共通のカウント方法を使用するため）
                  // 値が実際に変更された場合のみ更新（過剰なAPI呼び出しを防ぐ）
                  const currentCountAttr = cartData.attributes && cartData.attributes['Cart Item Count (Excluding Gift Wrapping)'];
                  const currentCountValue = currentCountAttr ? parseInt(currentCountAttr) : null;

                  if (currentCountValue !== itemCountExcludingGiftWrapping) {
                    // updateCartAttributes関数を使用（リトライロジック付き）
                    if (window.updateCartAttributes) {
                      window.updateCartAttributes({ 'Cart Item Count (Excluding Gift Wrapping)': String(itemCountExcludingGiftWrapping) })
                        .catch(error => console.error('Error saving cart item count to attributes in onCartUpdate (main-cart-items):', error));
                    } else {
                      // フォールバック: 直接fetch（リトライなし）
                      fetch('/cart/update.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                          attributes: { 'Cart Item Count (Excluding Gift Wrapping)': String(itemCountExcludingGiftWrapping) }
                        })
                      }).catch(error => console.error('Error saving cart item count to attributes in onCartUpdate (main-cart-items):', error));
                    }
                  }

                  const cartIconBubbles = document.querySelectorAll('.cart-count-bubble span');
                  cartIconBubbles.forEach(bubble => {
                    bubble.textContent = itemCountExcludingGiftWrapping;
                  });

                  // "Your Cart"の右隣のカウントも更新
                  const cartItemsElement = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
                  if (cartItemsElement && typeof cartItemsElement.updatePageHeadingCartCount === 'function') {
                    cartItemsElement.updatePageHeadingCartCount(itemCountExcludingGiftWrapping);
                  }
                })
                .catch(error => {
                  console.error('[onCartUpdate] Error fetching cart data for select restoration:', error);
                  // エラー時は保存した値から復元（itemKeyとvariant_idの両方で試行）
                  const updatedSelects = document.querySelectorAll('.gift-wrapping-selector');
                  updatedSelects.forEach(select => {
                    const itemKey = select.getAttribute('data-item-key');
                    const variantId = select.getAttribute('data-variant-id');
                    let valueToRestore = null;

                    // 優先順位1: itemKeyで復元
                    if (itemKey && savedSelectValues.has(itemKey)) {
                      valueToRestore = savedSelectValues.get(itemKey);
                      console.log(`[onCartUpdate] Restored select value for ${itemKey} from saved value (fallback, by itemKey): ${valueToRestore}`);
                    }
                    // 優先順位2: variant_idで復元
                    else if (variantId && savedSelectValuesByVariantId.has(variantId)) {
                      valueToRestore = savedSelectValuesByVariantId.get(variantId);
                      console.log(`[onCartUpdate] Restored select value for variant_id ${variantId} from saved value (fallback, by variantId): ${valueToRestore}`);
                    }

                    if (valueToRestore) {
                      select.value = valueToRestore;
                    }
                  });
                });
            }, 100);
          } else {
            // selectの値が保存されていない場合でも、カウントは更新
            setTimeout(() => {
              fetch('/cart.js')
                .then(response => response.json())
                .then(cartData => {
                  const itemCountExcludingGiftWrapping = window.calculateCartItemCountExcludingGiftWrapping
                    ? window.calculateCartItemCountExcludingGiftWrapping(cartData)
                    : cartData.item_count;

                  // cart.attributesに件数を保存（全ページで共通のカウント方法を使用するため）
                  // 値が実際に変更された場合のみ更新（過剰なAPI呼び出しを防ぐ）
                  const currentCountAttr = cartData.attributes && cartData.attributes['Cart Item Count (Excluding Gift Wrapping)'];
                  const currentCountValue = currentCountAttr ? parseInt(currentCountAttr) : null;

                  if (currentCountValue !== itemCountExcludingGiftWrapping) {
                    // updateCartAttributes関数を使用（リトライロジック付き）
                    if (window.updateCartAttributes) {
                      window.updateCartAttributes({ 'Cart Item Count (Excluding Gift Wrapping)': String(itemCountExcludingGiftWrapping) })
                        .catch(error => console.error('Error saving cart item count to attributes in onCartUpdate (no select values):', error));
                    } else {
                      // フォールバック: 直接fetch（リトライなし）
                      fetch('/cart/update.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                          attributes: { 'Cart Item Count (Excluding Gift Wrapping)': String(itemCountExcludingGiftWrapping) }
                        })
                      }).catch(error => console.error('Error saving cart item count to attributes in onCartUpdate (no select values):', error));
                    }
                  }

                  const cartIconBubbles = document.querySelectorAll('.cart-count-bubble span');
                  cartIconBubbles.forEach(bubble => {
                    bubble.textContent = itemCountExcludingGiftWrapping;
                  });

                  // "Your Cart"の右隣のカウントも更新
                  const cartItemsElement = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
                  if (cartItemsElement && typeof cartItemsElement.updatePageHeadingCartCount === 'function') {
                    cartItemsElement.updatePageHeadingCartCount(itemCountExcludingGiftWrapping);
                  }
                })
                .catch(error => console.error('Error updating cart count in onCartUpdate:', error));
            }, 150);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    const sections = [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'header',
        selector: '#mobile-cart-icon-bubble',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
    ];

    const mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems && mainCartItems.dataset.id) {
      sections.push({
        id: 'main-cart-items',
        section: mainCartItems.dataset.id,
        selector: '.js-contents',
      });
    }

    const mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartFooter && mainCartFooter.dataset.id) {
      sections.push({
        id: 'main-cart-footer',
        section: mainCartFooter.dataset.id,
        selector: '.js-contents',
      });
    }

    return sections;
  }

  updateQuantity(line, quantity, event, name, variantId) {
    console.log('updateQuantity called - line:', line, 'quantity:', quantity, 'name:', name, 'variantId:', variantId);

    // グローバルロックを使用して複数の同時更新を防ぐ
    return window.cartUpdateQueue.executeWithLock(async () => {
      // ロック取得後、処理中チェック（ロック内でチェックすることで確実に防ぐ）
    if (this.isUpdating) {
      console.log('Update already in progress, ignoring duplicate request');
      return;
    }

      // 数量変更前に、現在の数量入力フィールドの値を保存（グローバルスコープに保存）
      // これにより、renderContentsが呼ばれた際に、変更後の数量を保持できる
      // 注意: data-index属性は item.index + 1 なので、line (item.index) に +1 して保存する
      if (!window.savedQuantityValues) {
        window.savedQuantityValues = new Map();
      }

      // 商品を削除する場合（quantity=0）は、savedQuantityValuesから削除する
      if (quantity === 0) {
        const quantityInput = document.getElementById(`Quantity-${line}`) || document.querySelector(`[data-index="${line}"].quantity__input`);
        if (quantityInput) {
          const dataIndex = quantityInput.dataset.index || String(parseInt(line));
          window.savedQuantityValues.delete(dataIndex);
          console.log(`Removed quantity value for line ${line} (data-index: ${dataIndex}) from saved values (item being removed)`);
        } else {
          const dataIndex = String(parseInt(line));
          window.savedQuantityValues.delete(dataIndex);
          console.log(`Removed quantity value for line ${line} (data-index: ${dataIndex}) from saved values without input element (item being removed)`);
        }
      } else {
        // 数量変更の場合のみ保存
        const quantityInput = document.getElementById(`Quantity-${line}`) || document.querySelector(`[data-index="${line}"].quantity__input`);
        if (quantityInput) {
          // data-index属性の値（item.index + 1）をキーとして使用
          const dataIndex = quantityInput.dataset.index || String(parseInt(line));
          window.savedQuantityValues.set(dataIndex, quantity);
          console.log(`Saved quantity value for line ${line} (data-index: ${dataIndex}): ${quantity} (before DOM update)`);
        } else {
          // 数量入力フィールドが見つからない場合でも、line + 1 をキーとして保存
          const dataIndex = String(parseInt(line));
          window.savedQuantityValues.set(dataIndex, quantity);
          console.log(`Saved quantity value for line ${line} (data-index: ${dataIndex}) without input element: ${quantity} (before DOM update)`);
        }
      }

    this.isUpdating = true;
    this.enableLoading(line);

    // グローバルローディング表示
    const loader = document.getElementById('loader');
    const loaderBg = document.querySelector('.modal-bg');
    if (loader) loader.style.display = 'block';
    if (loaderBg) loaderBg.style.display = 'block';

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

      console.log('updateQuantity - request body:', body);

    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

      try {
    // 409エラー時のリトライ機能を追加
    const makeRequest = async (retryCount = 0) => {
      const response = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } });

      if (!response.ok && response.status === 409 && retryCount < 3) {
        console.info(`⏱️ Cart conflict detected, auto-retrying... (attempt ${retryCount + 1}/3)`);
        await new Promise(resolve => setTimeout(resolve, 500 * (retryCount + 1))); // 500ms, 1000ms, 1500ms
        return makeRequest(retryCount + 1);
      }

      return response;
    };

        const response = await makeRequest();
        const state = await response.text();
        const parsedState = JSON.parse(state);

        // エラーがある場合は従来の処理を続行
          if (parsedState.errors) {
          console.error('Cart API error:', parsedState.errors);

          // エラーメッセージを詳細にログ出力
          const errorMessage = JSON.stringify(parsedState.errors);
          console.error('Error details:', errorMessage);

          // "line parameter is invalid"エラーの場合でも、まずはエラーを表示して処理を続行
          // ページリロードは最後の手段として使用
          if (errorMessage.includes('line') || errorMessage.includes('invalid')) {
            console.warn('Line parameter error detected, but continuing with error handling instead of immediate reload');
            // ページリロードせず、エラー処理を続行
          }

          // lineはitem.index（1ベースの数値）を使用
          const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          if (quantityElement) {
            quantityElement.value = quantityElement.getAttribute('value');
          }
            this.updateLiveRegions(line, parsedState.errors);
          this.disableLoading(line);

          // エラーが発生した場合でも、ページリロードせずに処理を続行
          // ユーザーにエラーメッセージを表示
          const errorText = typeof parsedState.errors === 'string' ? parsedState.errors : JSON.stringify(parsedState.errors);
          console.error('Cart update error:', errorText);

          // エラー時も確実にisUpdatingをリセット
          this.isUpdating = false;

            return;
          }

        // エラーがない場合はDOMを更新（ページリロードなし）
        // renderContentsが完了するまで待機（バックグラウンド処理も含めて）
        // lineを渡して、DOM更新後にローディング状態を再適用できるようにする
        // quantityを渡して、数量変更の場合は背景チェック処理をスキップできるようにする
        console.log('Starting renderContents, line:', line, 'quantity:', quantity);
        try {
          await this.renderContents(parsedState, line, quantity);
          console.log('renderContents completed successfully, line:', line);
        } catch (renderError) {
          console.error('Error in renderContents:', renderError);
          // renderContentsでエラーが発生しても、ローディングは非表示にする
        }

        // 数量変更の場合、商品の小計が更新されるまで待機（フラグベース）
        if (quantity > 0) {
          console.log('Quantity updated, waiting for line item subtotal to update...');

          // カートAPIから最新の商品情報を取得（1回のみ、エラー時はスキップ）
          let expectedLinePrice = null;
          let updatedItemKey = null;
          try {
            const latestCartData = await fetch('/cart.js').then(r => {
              if (!r.ok) throw new Error(`HTTP error! status: ${r.status}`);
              return r.json();
            });
            if (latestCartData && latestCartData.items) {
              // 更新された商品の小計を取得（lineはitem.index（1ベース））
              const updatedItem = latestCartData.items.find(item => item.index === parseInt(line));

              if (updatedItem) {
                expectedLinePrice = updatedItem.final_line_price || updatedItem.original_line_price;
                updatedItemKey = updatedItem.key;
              }
            }
          } catch (error) {
            console.warn('Failed to fetch cart data for line item subtotal check:', error);
          }

          // フラグベースの待機: フラグが立つまで待機、タイムアウトで強制終了
          const startTime = Date.now();
          const timeout = 1600; // タイムアウト: 1.6秒
          const pollInterval = 50; // ポーリング間隔: 50ms（より頻繁にチェック）

          let isUpdated = false;

          // フラグが立つか、タイムアウトするまで待機
          while (!isUpdated && (Date.now() - startTime) < timeout) {
            // フラグをチェック
            if (window.lineItemSubtotalUpdated) {
              console.log('Line item subtotal updated flag detected');

              // フラグが立った場合、実際の商品小計が期待値と一致するか確認
              if (expectedLinePrice !== null && updatedItemKey) {
                // DOMから現在の商品の小計を取得
                let cartItemRow = null;

                // 方法1: data-item-key属性で検索（最も確実）
                if (updatedItemKey) {
                  cartItemRow = document.querySelector(`tr.cart-item[data-item-key="${updatedItemKey}"]`);
                }

                // 方法2: 数量入力フィールドから親要素を取得（data-item-key属性を使用）
                if (!cartItemRow && updatedItemKey) {
                  const quantityInput = document.querySelector(`input.quantity__input[data-item-key="${updatedItemKey}"]`);
                  if (quantityInput) {
                    cartItemRow = quantityInput.closest('tr.cart-item');
                  }
                }

                // 方法3: data-index属性で検索（フォールバック）
                if (!cartItemRow && updatedItemKey) {
                  cartItemRow = document.querySelector(`tr.cart-item[data-index="${updatedItemKey}"]`);
                }

                // 方法4: IDで検索（フォールバック）
                if (!cartItemRow) {
                  const quantityInput = document.getElementById(`Quantity-${line}`);
                  if (quantityInput) {
                    cartItemRow = quantityInput.closest('tr.cart-item');
                  }
                }

                if (cartItemRow) {
                  const priceWrapper = cartItemRow.querySelector('.cart-item__price-wrapper');
                  if (priceWrapper) {
                    // 複数のセレクターで価格要素を取得
                    let priceElement = priceWrapper.querySelector('.price--end');
                    if (!priceElement) {
                      priceElement = priceWrapper.querySelector('.cart-item__final-price');
                    }
                    if (!priceElement) {
                      priceElement = priceWrapper.querySelector('.price');
                    }

                    if (priceElement) {
                      const currentPriceText = priceElement.textContent || '';
                      // 金額を数値に変換して比較（通貨記号やカンマを除去）
                      const currentPriceValue = parseFloat(currentPriceText.replace(/[^\d.]/g, '')) * 100; // セント単位に変換

                      // 期待値と一致するか確認（±1セントの誤差を許容）
                      if (!isNaN(currentPriceValue) && Math.abs(currentPriceValue - expectedLinePrice) <= 1) {
                        console.log('Line item subtotal updated and matches expected value:', expectedLinePrice);
                        isUpdated = true;
                        break;
                      }
                    }
                  }
                }
            } else {
                // 期待値がない場合、フラグが立っていれば完了とみなす
                isUpdated = true;
                break;
              }
            }

            // ポーリング間隔待機
            await new Promise(resolve => setTimeout(resolve, pollInterval));
          }

          if (!isUpdated) {
            const elapsedTime = Date.now() - startTime;
            console.log(`Line item subtotal update timeout after ${elapsedTime}ms, proceeding anyway (this is normal if update is slow)`);
          } else {
            const elapsedTime = Date.now() - startTime;
            console.log(`Line item subtotal updated successfully after ${elapsedTime}ms`);
          }

          // フラグをリセット
          window.lineItemSubtotalUpdated = false;
        }

        // 削除処理の場合、カートフッターの合計金額が更新されるまで待機（フラグベース）
        // ただし、checkAndHideGiftWrappingUI()内でギフトラッピング商品を削除する場合はスキップ（重複を避けるため）
        if (quantity === 0 && !window.giftWrappingItemWillBeRemoved) {
          console.log('Item deletion completed, waiting for cart footer total to update...');

          // カートAPIから最新の合計金額を取得（1回のみ、エラー時はスキップ）
          let expectedTotalPrice = null;
          try {
            const latestCartData = await fetch('/cart.js').then(r => {
              if (!r.ok) throw new Error(`HTTP error! status: ${r.status}`);
              return r.json();
            });
            expectedTotalPrice = latestCartData ? latestCartData.total_price : null;
          } catch (error) {
            console.warn('Failed to fetch cart data, proceeding without price check:', error);
          }

          // フラグベースの待機: フラグが立つまで待機、タイムアウトで強制終了
          const startTime = Date.now();
          const timeout = 2000; // タイムアウト: 2秒
          const pollInterval = 50; // ポーリング間隔: 50ms（より頻繁にチェック）

          let isUpdated = false;

          // フラグが立つか、タイムアウトするまで待機
          while (!isUpdated && (Date.now() - startTime) < timeout) {
            // フラグをチェック
            if (window.cartTotalUpdated) {
              console.log('Cart footer total updated flag detected');

              // フラグが立った場合、実際の合計金額が期待値と一致するか確認
              if (expectedTotalPrice !== null) {
                const cartFooter = document.getElementById('main-cart-footer');
                if (cartFooter) {
                  const totalPriceElement = cartFooter.querySelector('.cart__totals .cart__total-price');
                  if (totalPriceElement) {
                    const currentTotalText = totalPriceElement.textContent || '';
                    const currentTotalValue = parseFloat(currentTotalText.replace(/[^\d.]/g, '')) * 100; // セント単位に変換

                    // 期待値と一致するか確認（±1セントの誤差を許容）
                    if (Math.abs(currentTotalValue - expectedTotalPrice) <= 1) {
                      console.log('Cart footer total updated and matches expected value:', expectedTotalPrice);
                      isUpdated = true;
                      break;
                    }
                  }
                }
              } else {
                // 期待値がない場合、フラグが立っていれば完了とみなす
                isUpdated = true;
                break;
              }
            }

            // ポーリング間隔待機
            await new Promise(resolve => setTimeout(resolve, pollInterval));
          }

          if (!isUpdated) {
            const elapsedTime = Date.now() - startTime;
            console.log(`Cart footer total update timeout after ${elapsedTime}ms, proceeding anyway (this is normal if update is slow)`);
          } else {
            const elapsedTime = Date.now() - startTime;
            console.log(`Cart footer total updated successfully after ${elapsedTime}ms`);
          }

          // フラグをリセット
          window.cartTotalUpdated = false;
        } else {
          // 削除処理でない場合、通常の待機時間
          await new Promise(resolve => setTimeout(resolve, 200));
        }

        // カートが空になった場合、updateCartAttributesの完了を待つ（conflictを避けるため）
        const finalCartData = await fetch('/cart.js').then(r => r.json()).catch(() => ({ item_count: 0 }));
        const finalItemCountExcludingGiftWrapping = window.calculateCartItemCountExcludingGiftWrapping
          ? window.calculateCartItemCountExcludingGiftWrapping(finalCartData)
          : finalCartData.item_count;

        if (finalItemCountExcludingGiftWrapping === 0 && (window.pendingCartAttributeUpdate || window.cartAttributeUpdateCompleted !== undefined)) {
          console.log('Waiting for updateCartAttributes to complete (cart empty)...');

          // フラグベースの待機: フラグが立つまで待機、タイムアウトで強制終了
          const startTime = Date.now();
          const timeout = 2000; // タイムアウト: 2秒
          const pollInterval = 50; // ポーリング間隔: 50ms

          let isCompleted = false;

          // フラグが立つか、タイムアウトするまで待機
          while (!isCompleted && (Date.now() - startTime) < timeout) {
            // フラグをチェック
            if (window.cartAttributeUpdateCompleted === true) {
              console.log('Cart attribute update completed flag detected');
              isCompleted = true;
              break;
            }

            // Promiseが存在する場合、Promise.raceで待機（フォールバック）
            if (window.pendingCartAttributeUpdate) {
              try {
                await Promise.race([
                  window.pendingCartAttributeUpdate,
                  new Promise(resolve => setTimeout(resolve, pollInterval))
                ]);
                // Promiseが完了した場合、フラグを確認
                if (window.cartAttributeUpdateCompleted === true) {
                  isCompleted = true;
                  break;
                }
              } catch (error) {
                console.error('Error waiting for updateCartAttributes:', error);
                // エラー時も完了とみなす
                isCompleted = true;
                break;
              }
            } else {
              // Promiseがない場合、ポーリング間隔待機
              await new Promise(resolve => setTimeout(resolve, pollInterval));
            }
          }

          if (!isCompleted) {
            const elapsedTime = Date.now() - startTime;
            console.log(`Cart attribute update timeout after ${elapsedTime}ms, proceeding anyway`);
          } else {
            const elapsedTime = Date.now() - startTime;
            console.log(`Cart attribute update completed successfully after ${elapsedTime}ms`);
          }

          // フラグをリセット
          window.cartAttributeUpdateCompleted = undefined;
        }

        // checkAndHideGiftWrappingUI()内でギフトラッピング商品を削除した場合、合計金額更新待機が完了するまで待機
        if (window.giftWrappingItemWillBeRemoved || window.giftWrappingTotalUpdateCompleted !== undefined) {
          console.log('Waiting for gift wrapping total update to complete before hiding loading spinner...');

          // フラグベースの待機: フラグが立つまで待機、タイムアウトで強制終了
          const startTime = Date.now();
          const timeout = 4000; // タイムアウト: 4秒（合計金額更新待機のタイムアウト2秒 + 余裕を持たせる）
          const pollInterval = 50; // ポーリング間隔: 50ms

          let isCompleted = false;

          // フラグが立つか、タイムアウトするまで待機
          while (!isCompleted && (Date.now() - startTime) < timeout) {
            // フラグをチェック
            if (window.giftWrappingTotalUpdateCompleted === true) {
              console.log('Gift wrapping total update completed flag detected');
              isCompleted = true;
              break;
            }

            // ポーリング間隔待機
            await new Promise(resolve => setTimeout(resolve, pollInterval));
          }

          if (!isCompleted) {
            const elapsedTime = Date.now() - startTime;
            console.log(`Gift wrapping total update wait timeout after ${elapsedTime}ms, proceeding anyway`);
          } else {
            const elapsedTime = Date.now() - startTime;
            console.log(`Gift wrapping total update wait completed successfully after ${elapsedTime}ms`);
          }

          // フラグをリセット
          window.giftWrappingTotalUpdateCompleted = undefined;
        }

        // renderContents完了後、確実にローディングを非表示にする
        console.log('Disabling loading after renderContents completion, line:', line, 'isUpdating:', this.isUpdating);

        // まず、isUpdatingフラグをリセット
        this.isUpdating = false;

        // ローディングを非表示にする（確実に）
        // disableLoading内でDOM更新後の新しい要素も探すように修正済み
        this.disableLoading(line);

        // グローバルローディングも非表示
        if (loader) loader.style.display = 'none';
        if (loaderBg) loaderBg.style.display = 'none';

        // さらに確実にするため、複数回チェック（DOM更新後の非同期処理が完了するまで待つ）
        const cleanupLoading = () => {
          // cart__items--disabledクラスを確実に削除
          const mainCartItemsCheck = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
          if (mainCartItemsCheck && mainCartItemsCheck.classList.contains('cart__items--disabled')) {
            mainCartItemsCheck.classList.remove('cart__items--disabled');
            console.log('Removed cart__items--disabled class in cleanup');
          }

          // すべてのローディングスピナーを非表示にする（DOM更新後の新しい要素も含む）
          document.querySelectorAll('.loading__spinner').forEach((overlay) => {
            overlay.classList.add('hidden');
            overlay.style.display = 'none';
          });

          // グローバルローディングも非表示
          const loaderCheck = document.getElementById('loader');
          const loaderBgCheck = document.querySelector('.modal-bg');
          if (loaderCheck) loaderCheck.style.display = 'none';
          if (loaderBgCheck) loaderBgCheck.style.display = 'none';

          // isUpdatingフラグも確認
          if (this.isUpdating) {
            this.isUpdating = false;
            console.log('Reset isUpdating flag in cleanup');
          }
        };

        // 即座に実行
        cleanupLoading();

        // 50ms後に再実行（DOM更新直後の要素を確実に取得）
        setTimeout(cleanupLoading, 50);

        // 150ms後に再実行（非同期処理が完了するまで待つ）
        setTimeout(cleanupLoading, 150);

        // 300ms後にも再実行（念のため）
        setTimeout(cleanupLoading, 300);

        // 500ms後にも再実行（さらに念のため）
        setTimeout(cleanupLoading, 500);

        // カートが空になった場合、さらに確実にローディングスピナーを非表示にする
        if (finalItemCountExcludingGiftWrapping === 0) {
          setTimeout(() => {
            console.log('Final cleanup for empty cart...');
            cleanupLoading();
            // さらに確実にするため、もう一度実行
            setTimeout(cleanupLoading, 200);
          }, 1000);
        }
      } catch (error) {
        console.error('Cart update failed:', error);
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) {
        errors.textContent = window.cartStrings.error;
        }

        // エラー時も確実にリセット
        this.disableLoading(line);
        if (loader) loader.style.display = 'none';
        if (loaderBg) loaderBg.style.display = 'none';
        this.isUpdating = false;

        // ネットワークエラーや予期しないエラーの場合もページリロード
        alert('An error occurred while updating the cart. The page will be reloaded.');
        window.location.reload();
      } finally {
        // エラー時のみリセット（正常完了時は既にリセット済み）
        // 正常完了時はrenderContents完了後にリセット済みなので、ここではエラー時のみ処理
        if (this.isUpdating) {
          console.log('Resetting loading state in finally block (error case)');
        this.disableLoading(line);
        // グローバルローディング非表示
        if (loader) loader.style.display = 'none';
        if (loaderBg) loaderBg.style.display = 'none';
        // 処理完了フラグをリセット
        this.isUpdating = false;
        }

        // DOM更新後、カスタム要素を再初期化（ボタンが押せなくなる問題を防ぐ）
        setTimeout(() => {
          // カスタム要素が再初期化されるのを待つ
          const removeButtons = document.querySelectorAll('cart-remove-button');
          const quantityInputs = document.querySelectorAll('quantity-input');
          console.log('Custom elements after DOM update - remove buttons:', removeButtons.length, 'quantity inputs:', quantityInputs.length);

          // 念のため、残っているcart__items--disabledクラスを削除
          const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
          if (mainCartItems && mainCartItems.classList.contains('cart__items--disabled')) {
            mainCartItems.classList.remove('cart__items--disabled');
            console.log('Removed cart__items--disabled class in finally block');
          }
        }, 100);
      }
      });
  }

  async renderContents(parsedState, loadingLine = null, quantity = null) {
    // DOM更新前に、現在のギフトラッピングselectの値を保存
    const savedSelectValues = new Map();
    const currentSelects = document.querySelectorAll('.gift-wrapping-selector');
    currentSelects.forEach(select => {
      const itemKey = select.getAttribute('data-item-key');
      if (itemKey && select.value) {
        savedSelectValues.set(itemKey, select.value);
        console.log(`Saved select value for ${itemKey}: ${select.value}`);
      }
    });

    // DOM更新前に、現在の数量入力フィールドの値を保存
    // グローバルスコープに保存された値があれば優先的に使用
    const savedQuantityValues = new Map();

    // まず、グローバルスコープに保存された値を使用
    if (window.savedQuantityValues) {
      window.savedQuantityValues.forEach((value, key) => {
        savedQuantityValues.set(key, value);
        console.log(`Using saved quantity value from global scope for index ${key}: ${value}`);
      });
    }

    // 次に、現在のDOMから数量入力フィールドの値を取得（グローバルスコープにない場合のみ）
    const currentQuantityInputs = this.querySelectorAll('.quantity__input');
    currentQuantityInputs.forEach(input => {
      const index = input.dataset.index;
      if (index) {
        // グローバルスコープに値がない場合のみ、DOMから取得
        if (!savedQuantityValues.has(index)) {
          const quantity = parseInt(input.value);
          if (!isNaN(quantity)) {
            savedQuantityValues.set(index, quantity);
            console.log(`Saved quantity value for index ${index} from DOM: ${quantity}`);
          }
        }
      }
    });

    // カートフッター更新完了フラグをリセット
    window.cartTotalUpdated = false;
    // 商品小計更新完了フラグをリセット
    window.lineItemSubtotalUpdated = false;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);
      console.log('Updating section:', section.id, 'Element found:', !!sectionElement);

      if (sectionElement && parsedState.sections && parsedState.sections[section.section]) {
        const targetElement = sectionElement.querySelector(section.selector);
        console.log('Target element found:', !!targetElement, 'Selector:', section.selector);

        if (targetElement) {
          targetElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          console.log('Updated section:', section.id);

          // カートフッターが更新された場合、フラグを設定
          if (section.id === 'main-cart-footer') {
            window.cartTotalUpdated = true;
            console.log('Cart footer updated, flag set to true');
          }

          // カートアイテムセクションが更新された場合、商品小計更新フラグを設定
          if (section.id === 'main-cart-items') {
            window.lineItemSubtotalUpdated = true;
            console.log('Cart items section updated, line item subtotal flag set to true');
          }

          // DOM更新後、ローディングスピナーを確実に非表示にする（処理完了時）
          // ただし、まだ処理中の場合は表示を維持する必要があるため、ここでは非表示にしない
          // 代わりに、updateQuantity内でrenderContents完了後に非表示にする
        } else {
          console.warn('Target element not found for section:', section.id, 'Selector:', section.selector);
        }
      } else {
        if (!sectionElement) {
          console.warn('Section element not found:', section.id);
        }
        if (!parsedState.sections || !parsedState.sections[section.section]) {
          console.warn('Section data not found in response:', section.section);
        }
      }
    });

    // DOM更新後、ローディング状態を再適用（まだ処理中の場合は）
    // ただし、renderContents完了後すぐにupdateQuantity内でローディングを非表示にするため、
    // ここでは再適用しない（DOM更新によりスピナーが消えても、すぐに非表示になるため問題ない）

    // ギフトラッピング商品を除外したカート商品数を計算
    // /cart/changeエンドポイントのレスポンスにはitemsが含まれない可能性があるため、常にカートAPIから取得
    const giftVariantId = window.giftWrappingVariantId;
    let itemCountExcludingGiftWrapping = parsedState.item_count || 0;

    // 常にカートAPIから最新の情報を取得して計算（より確実）
    // 取得したデータを保存して、他の処理で再利用できるようにする
    let cartDataForReuse = null;
    if (giftVariantId) {
      try {
        cartDataForReuse = await fetch('/cart.js').then(r => r.json());
        this.lastCartData = cartDataForReuse; // 他の処理で再利用できるように保存
        itemCountExcludingGiftWrapping = window.calculateCartItemCountExcludingGiftWrapping
          ? window.calculateCartItemCountExcludingGiftWrapping(cartDataForReuse)
          : cartDataForReuse.item_count;
        console.log('renderContents - Calculated itemCountExcludingGiftWrapping from cart API:', itemCountExcludingGiftWrapping, 'cart.item_count:', cartDataForReuse.item_count, 'parsedState.item_count:', parsedState.item_count);

        // cart.attributesに件数を保存（全ページで共通のカウント方法を使用するため）
        // 値が実際に変更された場合のみ更新（過剰なAPI呼び出しを防ぐ）
        const currentCountAttr = cartDataForReuse.attributes && cartDataForReuse.attributes['Cart Item Count (Excluding Gift Wrapping)'];
        const currentCountValue = currentCountAttr ? parseInt(currentCountAttr) : null;

        if (currentCountValue !== itemCountExcludingGiftWrapping) {
          // updateCartAttributes関数を使用（リトライロジック付き）
          if (window.updateCartAttributes) {
            window.updateCartAttributes({ 'Cart Item Count (Excluding Gift Wrapping)': String(itemCountExcludingGiftWrapping) })
              .catch(error => console.error('Error saving cart item count to attributes in renderContents:', error));
          } else {
            // フォールバック: 直接fetch（リトライなし）
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                attributes: { 'Cart Item Count (Excluding Gift Wrapping)': String(itemCountExcludingGiftWrapping) }
              })
            }).catch(error => console.error('Error saving cart item count to attributes in renderContents:', error));
          }
        } else {
          console.log('Cart item count unchanged, skipping attribute update:', itemCountExcludingGiftWrapping);
        }
      } catch (error) {
        console.error('Error fetching cart data for count calculation:', error);
        // エラー時はparsedState.item_countから暫定的に計算（ギフトラッピング商品が1つあると仮定）
        if (parsedState.item_count > 0) {
          itemCountExcludingGiftWrapping = Math.max(0, parsedState.item_count - 1);
        }
      }
    }

    // カートアイコンのバッジを手動で更新（セクション更新が失敗した場合のバックアップ）
    // ギフトラッピング商品を除外したカウントを使用
    if (parsedState.item_count !== undefined) {
      // カートアイコンのカウントを更新（カートが空の場合は非表示）
      const cartIconBubbles = document.querySelectorAll('.cart-count-bubble');
      cartIconBubbles.forEach(bubble => {
        if (itemCountExcludingGiftWrapping > 0) {
          const bubbleSpan = bubble.querySelector('span');
          if (bubbleSpan) {
            bubbleSpan.textContent = itemCountExcludingGiftWrapping;
          }
          bubble.style.display = '';
        } else {
          bubble.style.display = 'none';
        }
      });
      console.log('Cart icon bubbles updated to (excluding gift wrapping):', itemCountExcludingGiftWrapping, 'original:', parsedState.item_count);
    }

    // "Your Cart"の右隣のカウントを更新（DOM更新後に確実に実行）
    // setTimeoutでDOM更新完了を待ってから実行
    setTimeout(() => {
      this.updatePageHeadingCartCount(itemCountExcludingGiftWrapping);
    }, 50);

    // DOM更新後、ギフトラッピングのUI状態を即座に復元（非同期処理の前に実行）
    // カートが空の場合はGift WrappingのUIを非表示にする（ギフトラッピング商品を除外したカウントを使用）
    if (itemCountExcludingGiftWrapping === 0) {
      console.log('Cart is empty, hiding gift wrapping UI...');

      const omakaseRadio = document.getElementById('omakase');
      const noneRadio = document.getElementById('none');
      const cartWrapping = document.querySelector('.cart-wrapping');
      const cartWrappingItem = document.querySelector('.cart-wrapping-item');
      const wrappingDetail = document.querySelector('.cart-wrapping-detail');
      const wrappingOptions = document.querySelectorAll('.wrapping-options');

      if (omakaseRadio) omakaseRadio.checked = false;
      if (noneRadio) noneRadio.checked = true;
      // .cart-wrapping要素全体を非表示にする（これが最も重要）
      if (cartWrapping) cartWrapping.style.display = 'none';
      if (cartWrappingItem) cartWrappingItem.style.display = 'none';
      if (wrappingDetail) wrappingDetail.style.display = 'none';
      wrappingOptions.forEach(opt => opt.style.display = 'none');

      console.log('Gift wrapping UI hidden for empty cart');
    } else {
      // カートに商品がある場合、ギフトラッピング対象商品があるかチェック
      // DOM更新後に確実にチェックするため、少し待機してからチェック
      // この処理は非同期で実行されるが、renderContentsの完了を待たない
      setTimeout(() => {
        const giftVariantId = window.giftWrappingVariantId;
        let hasWrappingEligibleItems = false;

        // DOMから全てのカートアイテムを取得
        const cartItems = document.querySelectorAll('[data-index][data-wrapping-ng-flag]');

        if (cartItems.length > 0) {
          // ギフトラッピング対象商品があるかチェック（wrappingNGFlagが1以外の商品）
          hasWrappingEligibleItems = Array.from(cartItems).some(cartItem => {
            // Gift Wrapping商品と非売品を除外（data-indexで判定）
            const itemKey = cartItem.getAttribute('data-index');
            if (!itemKey) return false;

            // カートAPIから商品情報を取得して確認
            if (parsedState.items) {
              const item = parsedState.items.find(i => i.key === itemKey);
              if (item) {
                // Gift Wrapping商品と非売品を除外
                if (giftVariantId && item.variant_id === giftVariantId) return false;
                if (item.product_type === '非売品') return false;
              }
            }

            // DOM内の該当商品のメタフィールドを取得
            const wrappingFlag = cartItem.getAttribute('data-wrapping-ng-flag');
            // wrappingNGFlagが1以外（0、空欄、未設定）ならギフトラッピング対象
            return wrappingFlag !== '1';
          });
        }

        console.log('Has wrapping eligible items (after DOM update):', hasWrappingEligibleItems);

        // ギフトラッピング対象商品がない場合、UIを非表示にする
        if (!hasWrappingEligibleItems && itemCountExcludingGiftWrapping > 0) {
          console.log('No wrapping eligible items, hiding gift wrapping UI...');

          const omakaseRadio = document.getElementById('omakase');
          const noneRadio = document.getElementById('none');
          const cartWrapping = document.querySelector('.cart-wrapping');
          const cartWrappingItem = document.querySelector('.cart-wrapping-item');
          const wrappingDetail = document.querySelector('.cart-wrapping-detail');
          const wrappingOptions = document.querySelectorAll('.wrapping-options');

          if (omakaseRadio) omakaseRadio.checked = false;
          if (noneRadio) noneRadio.checked = true;
          // .cart-wrapping要素全体を非表示にする（これが最も重要）
          if (cartWrapping) cartWrapping.style.display = 'none';
          if (cartWrappingItem) cartWrappingItem.style.display = 'none';
          if (wrappingDetail) wrappingDetail.style.display = 'none';
          wrappingOptions.forEach(opt => opt.style.display = 'none');

          console.log('Gift wrapping UI hidden (no eligible items)');
        }
      }, 100);

      // ギフトラッピング対象商品がある場合のみ、UIを復元
      if (itemCountExcludingGiftWrapping > 0) {
      // カートに商品がある場合のみ、ギフトラッピングのUI状態を復元
      const omakaseRadio = document.getElementById('omakase');
      if (omakaseRadio && omakaseRadio.checked) {
        console.log('Restoring gift wrapping UI after DOM update...');

        // omakaseが選択されている場合、selectを表示
        const wrappingOptions = document.querySelectorAll('.wrapping-options');
        wrappingOptions.forEach(opt => opt.style.display = 'block');

        const cartWrappingBlock = document.querySelector('.cart-wrapping-item');
        if (cartWrappingBlock) cartWrappingBlock.style.display = 'block';

        // 保存したselectの値を復元（優先）
        console.log('Restoring select values from saved values...');
          const selects = document.querySelectorAll('.gift-wrapping-selector');

        // カートAPIから最新の状態を取得して復元（非同期）
        // この処理は非同期で実行されるが、renderContentsの完了を待たない
        fetch('/cart.js')
          .then(response => response.json())
          .then(cartData => {
          selects.forEach(select => {
            const itemKey = select.getAttribute('data-item-key');
            if (itemKey) {
                let valueToRestore = null;

                // 優先順位: 1. 保存した値、2. カートAPIの値、3. parsedStateの値
                if (savedSelectValues.has(itemKey)) {
                  valueToRestore = savedSelectValues.get(itemKey);
                  console.log(`Restored select value for ${itemKey} from saved value: ${valueToRestore}`);
                } else if (cartData.items && cartData.items.length > 0) {
                  const item = cartData.items.find(i => i.key === itemKey);
                  if (item && item.properties && item.properties['Gift_Wrapping']) {
                    const giftWrappingValue = item.properties['Gift_Wrapping'];
                    if (giftWrappingValue === 'gift' || giftWrappingValue === 'none') {
                      valueToRestore = giftWrappingValue;
                      console.log(`Restored select value for ${itemKey} from cart API: ${giftWrappingValue}`);
                    }
                  }
                } else if (parsedState.items && parsedState.items.length > 0) {
                  const item = parsedState.items.find(i => i.key === itemKey);
                  if (item && item.properties && item.properties['Gift_Wrapping']) {
                    const giftWrappingValue = item.properties['Gift_Wrapping'];
                    if (giftWrappingValue === 'gift' || giftWrappingValue === 'none') {
                      valueToRestore = giftWrappingValue;
                      console.log(`Restored select value for ${itemKey} from parsedState: ${giftWrappingValue}`);
                    }
                  }
                }

                if (valueToRestore) {
                  select.value = valueToRestore;
                }
              }
            });

            // 数量入力フィールドの値を復元
            // 優先順位: 1. 保存した値、2. カートAPIの値
            console.log('Restoring quantity values from saved values or cart API...');
            const quantityInputs = this.querySelectorAll('.quantity__input');
            quantityInputs.forEach(input => {
              const index = input.dataset.index;
              if (index) {
                let quantityToRestore = null;

                // 優先順位: 1. 保存した値、2. カートAPIの値
                if (savedQuantityValues.has(index)) {
                  quantityToRestore = savedQuantityValues.get(index);
                  console.log(`Restored quantity value for index ${index} from saved value: ${quantityToRestore}`);
                } else if (cartData.items && cartData.items.length > 0) {
                  // カートAPIから数量を取得（indexは1ベースなので、item.indexと比較）
                  const item = cartData.items.find(item => {
                    // item.indexは1ベースなので、parseInt(index)と比較
                    return item.index === parseInt(index);
                  });
                  if (item) {
                    quantityToRestore = item.quantity;
                    console.log(`Restored quantity value for index ${index} from cart API: ${quantityToRestore}`);
                  }
                }

                if (quantityToRestore !== null) {
                  input.value = quantityToRestore;
                }
              }
            });
          })
          .catch(error => {
            console.error('Error fetching cart data for select restoration:', error);
            // エラー時は保存した値とparsedStateから復元
            selects.forEach(select => {
              const itemKey = select.getAttribute('data-item-key');
              if (itemKey) {
                if (savedSelectValues.has(itemKey)) {
                  const savedValue = savedSelectValues.get(itemKey);
                  select.value = savedValue;
                  console.log(`Restored select value for ${itemKey} from saved value (fallback): ${savedValue}`);
                } else if (parsedState.items && parsedState.items.length > 0) {
              const item = parsedState.items.find(i => i.key === itemKey);
              if (item && item.properties && item.properties['Gift_Wrapping']) {
                const giftWrappingValue = item.properties['Gift_Wrapping'];
                if (giftWrappingValue === 'gift' || giftWrappingValue === 'none') {
                  select.value = giftWrappingValue;
                      console.log(`Restored select value for ${itemKey} from parsedState (fallback): ${giftWrappingValue}`);
                    }
                }
              }
            }
          });

            // エラー時も数量入力フィールドの値を復元
            const quantityInputs = this.querySelectorAll('.quantity__input');
            quantityInputs.forEach(input => {
              const index = input.dataset.index;
              if (index && savedQuantityValues.has(index)) {
                const savedQuantity = savedQuantityValues.get(index);
                input.value = savedQuantity;
                console.log(`Restored quantity value for index ${index} (fallback): ${savedQuantity}`);
              }
            });
          });

        console.log('Restored gift wrapping UI after DOM update');
        } else {
          // omakaseが選択されていない場合でも、保存したselectの値を復元（ユーザーの選択を保持）
          console.log('Omakase not selected, but restoring saved select values...');
          const selects = document.querySelectorAll('.gift-wrapping-selector');

          // カートAPIから最新の状態を取得して復元（非同期）
          fetch('/cart.js')
            .then(response => response.json())
            .then(cartData => {
              selects.forEach(select => {
                const itemKey = select.getAttribute('data-item-key');
                if (itemKey) {
                  let valueToRestore = null;

                  // 優先順位: 1. 保存した値、2. カートAPIの値
                  if (savedSelectValues.has(itemKey)) {
                    valueToRestore = savedSelectValues.get(itemKey);
                    console.log(`Restored select value for ${itemKey} from saved value: ${valueToRestore}`);
                  } else if (cartData.items && cartData.items.length > 0) {
                    const item = cartData.items.find(i => i.key === itemKey);
                    if (item && item.properties && item.properties['Gift_Wrapping']) {
                      const giftWrappingValue = item.properties['Gift_Wrapping'];
                      if (giftWrappingValue === 'gift' || giftWrappingValue === 'none') {
                        valueToRestore = giftWrappingValue;
                        console.log(`Restored select value for ${itemKey} from cart API: ${giftWrappingValue}`);
                      }
                    }
                  }

                  if (valueToRestore) {
                    select.value = valueToRestore;
                  }
                }
              });

              // 数量入力フィールドの値を復元
              // 優先順位: 1. 保存した値、2. カートAPIの値
              console.log('Restoring quantity values from saved values or cart API (omakase not selected)...');
              const quantityInputs = this.querySelectorAll('.quantity__input');
              quantityInputs.forEach(input => {
                const index = input.dataset.index;
                if (index) {
                  let quantityToRestore = null;

                  // 優先順位: 1. 保存した値、2. カートAPIの値
                  if (savedQuantityValues.has(index)) {
                    quantityToRestore = savedQuantityValues.get(index);
                    console.log(`Restored quantity value for index ${index} from saved value: ${quantityToRestore}`);
                  } else if (cartData.items && cartData.items.length > 0) {
                    // カートAPIから数量を取得（indexは1ベースなので、item.indexと比較）
                    const item = cartData.items.find(item => {
                      // item.indexは1ベースなので、parseInt(index)と比較
                      return item.index === parseInt(index);
                    });
                    if (item) {
                      quantityToRestore = item.quantity;
                      console.log(`Restored quantity value for index ${index} from cart API: ${quantityToRestore}`);
                    }
                  }

                  if (quantityToRestore !== null) {
                    input.value = quantityToRestore;
                  }
                }
              });
            })
            .catch(error => {
              console.error('Error fetching cart data for select restoration:', error);
              // エラー時は保存した値から復元
              selects.forEach(select => {
                const itemKey = select.getAttribute('data-item-key');
                if (itemKey && savedSelectValues.has(itemKey)) {
                  const savedValue = savedSelectValues.get(itemKey);
                  select.value = savedValue;
                  console.log(`Restored select value for ${itemKey} from saved value (fallback): ${savedValue}`);
                }
              });

              // エラー時も数量入力フィールドの値を復元
              const quantityInputs = this.querySelectorAll('.quantity__input');
              quantityInputs.forEach(input => {
                const index = input.dataset.index;
                if (index && savedQuantityValues.has(index)) {
                  const savedQuantity = savedQuantityValues.get(index);
                  input.value = savedQuantity;
                  console.log(`Restored quantity value for index ${index} (fallback): ${savedQuantity}`);
                }
              });
            });
        }

        // DOM更新後、数量入力フィールドの値を復元（omakaseの選択状態に関係なく）
        // カートAPIから最新の数量を取得して復元
        // 非同期処理をPromiseでラップして、完了を待つ
        // 注意: 商品削除後、item.indexが変わる可能性があるため、item.keyを使用して復元する
        // renderContentsで取得したcartDataを再利用（過剰なAPI呼び出しを防ぐ）
        await new Promise((resolve) => {
          setTimeout(async () => {
            console.log('Restoring quantity values after DOM update...');
            try {
              // renderContentsで取得したデータを再利用、なければ新規取得
              let cartData = this.lastCartData;
              if (!cartData) {
                cartData = await fetch('/cart.js').then(r => r.json());
                this.lastCartData = cartData;
              } else {
                console.log('Reusing cartData from renderContents for quantity restoration');
              }
              const quantityInputs = this.querySelectorAll('.quantity__input');
              quantityInputs.forEach(input => {
                const itemKey = input.getAttribute('data-item-key');
                const index = input.dataset.index;

                // 優先順位: 1. 保存した値（window.savedQuantityValues）、2. カートAPIの値
                let quantityToRestore = null;

                if (itemKey) {
                  // まず、保存した値があるか確認（window.savedQuantityValuesを優先）
                  if (index && window.savedQuantityValues && window.savedQuantityValues.has(index)) {
                    quantityToRestore = window.savedQuantityValues.get(index);
                    console.log(`Restored quantity value for item ${itemKey} (index ${index}) from saved value: ${quantityToRestore}`);
                  } else {
                    // 保存した値がない場合、カートAPIから数量を取得
                    const item = cartData.items.find(item => item.key === itemKey);
                    if (item) {
                      quantityToRestore = item.quantity;
                      console.log(`Restored quantity value for item ${itemKey} (index ${index}) from cart API: ${quantityToRestore}`);
                    }
                  }
                } else if (index) {
                  // data-item-keyがない場合は、従来の方法で復元
                  // 優先順位: 1. 保存した値、2. カートAPIの値
                  if (window.savedQuantityValues && window.savedQuantityValues.has(index)) {
                    quantityToRestore = window.savedQuantityValues.get(index);
                    console.log(`Restored quantity value for index ${index} from saved value (after DOM update): ${quantityToRestore}`);
                  } else if (cartData.items && cartData.items.length > 0) {
                    // カートAPIから数量を取得（indexは1ベースなので、item.indexと比較）
                    const item = cartData.items.find(item => {
                      // item.indexは1ベースなので、parseInt(index)と比較
                      return item.index === parseInt(index);
                    });
                    if (item) {
                      quantityToRestore = item.quantity;
                      console.log(`Restored quantity value for index ${index} from cart API (after DOM update): ${quantityToRestore}`);
                    }
                  }
                }

                if (quantityToRestore !== null) {
                  input.value = quantityToRestore;
                  // カスタム要素のvalue属性も更新（念のため）
                  input.setAttribute('value', quantityToRestore);
                }
              });

              // さらに確実にするため、もう一度復元を試みる（DOM更新が完了するまで待つ）
              setTimeout(() => {
                const quantityInputs = this.querySelectorAll('.quantity__input');
                quantityInputs.forEach(input => {
                  const index = input.dataset.index;
                  const itemKey = input.getAttribute('data-item-key');

                  // 保存した値がある場合、現在の値と異なる場合は更新
                  if (index && window.savedQuantityValues && window.savedQuantityValues.has(index)) {
                    const savedQuantity = window.savedQuantityValues.get(index);
                    const currentValue = parseInt(input.value);
                    if (currentValue !== savedQuantity) {
                      input.value = savedQuantity;
                      input.setAttribute('value', savedQuantity);
                      console.log(`Re-restored quantity value for index ${index} from saved value (second attempt): ${savedQuantity}`);
                    }
                  } else if (itemKey) {
                    // item.keyを使用してカートAPIから数量を取得
                    fetch('/cart.js').then(r => r.json()).then(cartData => {
                      const item = cartData.items.find(item => item.key === itemKey);
                      if (item) {
                        const currentValue = parseInt(input.value);
                        if (currentValue !== item.quantity) {
                          input.value = item.quantity;
                          input.setAttribute('value', item.quantity);
                          console.log(`Re-restored quantity value for item ${itemKey} from cart API (second attempt): ${item.quantity}`);
                        }
                      }
                    }).catch(error => console.warn('Failed to re-restore quantity:', error));
                  }
                });
              }, 200);
            } catch (error) {
              console.error('Error fetching cart data for quantity restoration:', error);
              // エラー時は保存した値から復元
              const quantityInputs = this.querySelectorAll('.quantity__input');
              quantityInputs.forEach(input => {
                const index = input.dataset.index;
                if (index && savedQuantityValues.has(index)) {
                  const savedQuantity = savedQuantityValues.get(index);
                  input.value = savedQuantity;
                  console.log(`Restored quantity value for index ${index} from saved value (fallback after DOM update): ${savedQuantity}`);
                }
              });
            }
            resolve();
          }, 100);
        });
      }
    }

    // チェック処理を並列実行し、完了するまで待機（フラグベース）
    // 数量変更の場合（quantity > 0）は背景チェック処理をスキップ（商品が削除されることはないため）
    if (quantity === null || quantity === 0) {
      // カートが空になった場合、checkAndRemoveGiftWrappingOnly()がページリロードを実行するため、
      // 背景チェック処理の完了待機をスキップし、即座にUIを更新してLoading spinnerを非表示にする
      const isCartEmpty = itemCountExcludingGiftWrapping === 0;

      if (isCartEmpty) {
        console.log('Cart is empty, skipping background checks wait (page reload will occur)');
        // 背景チェック処理は非同期で開始するが、完了を待たない（ページリロードが発生するため）
        Promise.all([
          this.checkAndRemoveGiftWrappingOnly(),
          this.checkAndHideGiftWrappingUI()
        ]).catch(error => {
          console.error('Error in background checks:', error);
        });
        // 即座にUIを更新してLoading spinnerを非表示にする（ページリロード前に実行）
        // 注意: checkAndRemoveGiftWrappingOnly()がページリロードを実行するため、
        // この処理はページリロード前に実行される必要がある
      } else {
        // 背景チェック処理完了フラグをリセット
        window.backgroundChecksCompleted = false;

        // チェック処理を並列実行（非同期で開始）
        const backgroundChecksPromise = Promise.all([
          this.checkAndRemoveGiftWrappingOnly(),
          this.checkAndHideGiftWrappingUI()
        ]).then(() => {
          window.backgroundChecksCompleted = true;
          console.log('Background checks completed, flag set to true');
        }).catch(error => {
          console.error('Error in background checks:', error);
          // エラー時もフラグを設定（エラーでも完了とみなす）
          window.backgroundChecksCompleted = true;
        });

        // フラグベースの待機: フラグが立つまで待機、タイムアウトで強制終了
        const startTime = Date.now();
        const timeout = 8000; // タイムアウト: 8秒（ギフトラッピング商品削除と合計金額更新を考慮して短縮）
        const pollInterval = 50; // ポーリング間隔: 50ms（より頻繁にチェック）

        let isCompleted = false;

        // フラグが立つか、タイムアウトするまで待機
        while (!isCompleted && (Date.now() - startTime) < timeout) {
          // フラグをチェック
          if (window.backgroundChecksCompleted) {
            console.log('Background checks completed flag detected');
            isCompleted = true;
            break;
          }

          // ポーリング間隔待機
          await new Promise(resolve => setTimeout(resolve, pollInterval));
        }

        if (!isCompleted) {
          const elapsedTime = Date.now() - startTime;
          console.log(`Background checks timeout after ${elapsedTime}ms, proceeding anyway`);
        } else {
          const elapsedTime = Date.now() - startTime;
          console.log(`Background checks completed successfully after ${elapsedTime}ms`);
        }

        // フラグをリセット
        window.backgroundChecksCompleted = false;
      }
    } else {
      console.log('Skipping background checks for quantity update (quantity > 0)');
    }

    // チェック処理完了後、最新のカート情報を取得してカウントを更新
    // タイムアウトを追加して、永遠に待機しないようにする
    // renderContentsで取得したcartDataを再利用（過剰なAPI呼び出しを防ぐ）
    try {
      let latestCartData = this.lastCartData;
      if (!latestCartData) {
        latestCartData = await Promise.race([
          fetch('/cart.js').then(r => r.json()),
          new Promise((resolve) => setTimeout(() => resolve(null), 1000)) // 1秒でタイムアウト
        ]);
        if (latestCartData) {
          this.lastCartData = latestCartData;
        }
      } else {
        console.log('Reusing cartData from renderContents for background checks');
      }

      if (latestCartData) {
        const latestItemCountExcludingGiftWrapping = window.calculateCartItemCountExcludingGiftWrapping
          ? window.calculateCartItemCountExcludingGiftWrapping(latestCartData)
          : itemCountExcludingGiftWrapping;

        // cart.attributesに件数を保存（全ページで共通のカウント方法を使用するため）
        // 値が実際に変更された場合のみ更新（過剰なAPI呼び出しを防ぐ）
        const currentCountAttr = latestCartData.attributes && latestCartData.attributes['Cart Item Count (Excluding Gift Wrapping)'];
        const currentCountValue = currentCountAttr ? parseInt(currentCountAttr) : null;

        if (currentCountValue !== latestItemCountExcludingGiftWrapping) {
          // updateCartAttributes関数を使用（リトライロジック付き）
          if (window.updateCartAttributes) {
            window.updateCartAttributes({ 'Cart Item Count (Excluding Gift Wrapping)': String(latestItemCountExcludingGiftWrapping) })
              .catch(error => console.error('Error saving cart item count to attributes after background checks:', error));
          } else {
            // フォールバック: 直接fetch（リトライなし）
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                attributes: { 'Cart Item Count (Excluding Gift Wrapping)': String(latestItemCountExcludingGiftWrapping) }
              })
            }).catch(error => console.error('Error saving cart item count to attributes after background checks:', error));
          }
        }

        // カートアイコンのバッジを更新
        // カートアイコンのカウントを更新（カートが空の場合は非表示）
        const cartIconBubbles = document.querySelectorAll('.cart-count-bubble');
        cartIconBubbles.forEach(bubble => {
          if (latestItemCountExcludingGiftWrapping > 0) {
            const bubbleSpan = bubble.querySelector('span');
            if (bubbleSpan) {
              bubbleSpan.textContent = latestItemCountExcludingGiftWrapping;
            }
            bubble.style.display = '';
          } else {
            bubble.style.display = 'none';
          }
        });

        // "Your Cart"の右隣のカウントも更新
        this.updatePageHeadingCartCount(latestItemCountExcludingGiftWrapping);

        // Dawnのカート更新イベントとして最新cartDataを通知
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: latestCartData });
        }

        console.log('Cart count updated after background checks:', latestItemCountExcludingGiftWrapping);
      }
    } catch (error) {
      console.error('Error updating cart count after background checks:', error);
    }

    // カートが空になった場合の処理（ギフトラッピング商品を除外したカウントを使用）
    if (itemCountExcludingGiftWrapping === 0) {
      const cartItems = document.querySelector('cart-items');
      if (cartItems) {
        cartItems.classList.add('is-empty');
      }

      // main-cart-footerを非表示
      const cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) {
        cartFooter.classList.add('is-empty');
      }

      // bodyタグのクラスを更新
      document.body.classList.remove('cart-has-items');
      document.body.classList.add('cart-empty');

      // カートが空になった時、確実にcart__items--disabledクラスを削除（クリックがブロックされないようにする）
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      if (mainCartItems && mainCartItems.classList.contains('cart__items--disabled')) {
        mainCartItems.classList.remove('cart__items--disabled');
        console.log('Removed cart__items--disabled class when cart became empty');
      }

      // isUpdatingフラグも確実にリセット（クリックがブロックされないようにする）
      if (this.isUpdating) {
        this.isUpdating = false;
        console.log('Reset isUpdating flag when cart became empty');
      }

      // ローディングスピナーを確実に非表示にする（ページリロード前に実行）
      // 注意: checkAndRemoveGiftWrappingOnly()がページリロードを実行するため、
      // この処理はページリロード前に実行される必要がある
      const currentLine = line || null;
      this.disableLoading(currentLine);
      console.log('Disabled loading spinner when cart became empty');

      // グローバルローディングも確実に非表示
      const loader = document.getElementById('loading-spinner');
      const loaderBg = document.getElementById('loading-spinner-bg');
      if (loader) loader.style.display = 'none';
      if (loaderBg) loaderBg.style.display = 'none';
      console.log('Hidden global loading when cart became empty');

      // グローバルロックも確実に解除（conflictを避けるため）
      if (window.cartUpdateQueue && window.cartUpdateQueue.isLocked) {
        console.warn('Cart update queue was locked when cart became empty, forcing unlock');
        window.cartUpdateQueue.isLocked = false;
        window.cartUpdateQueue.currentOperation = null;
      }

      // カート属性をクリア（おまかせギフトラッピングをリセット）
      // updateCartAttributes関数を使用（リトライロジック付き）
      // 注意: この処理は非同期で実行されるが、ローディングスピナーの非表示はupdateQuantity内で行う
      // Promiseを保存して、updateQuantity内で待つことができるようにする
      if (window.updateCartAttributes) {
        // フラグをリセット
        window.cartAttributeUpdateCompleted = false;

        // Promiseを保存して、updateQuantity内で待つことができるようにする
        window.pendingCartAttributeUpdate = window.updateCartAttributes({ 'おまかせギフトラッピング': '', 'Gift Wrap Count': '0', 'Gift_Wrapping_Selections': '' })
          .then(result => {
            // 完了フラグを設定
            window.cartAttributeUpdateCompleted = true;
            console.log('Cart attribute update completed, flag set to true');
            return result;
          })
          .catch(error => {
            console.error('Error clearing cart attributes:', error);
            // エラー時もフラグを設定（エラーでも完了とみなす）
            window.cartAttributeUpdateCompleted = true;
            return null; // エラー時もnullを返す
      })
      .finally(() => {
            // 完了したら削除
            delete window.pendingCartAttributeUpdate;
            // 完了後も確実にロックを解除
            if (window.cartUpdateQueue && window.cartUpdateQueue.isLocked) {
              console.log('Unlocking cart update queue after attribute update completion');
              window.cartUpdateQueue.isLocked = false;
              window.cartUpdateQueue.currentOperation = null;
            }
          });
        console.log('Started updateCartAttributes for empty cart, waiting in updateQuantity...');
      } else {
        // フォールバック: 直接fetch（リトライなし）
        window.cartAttributeUpdateCompleted = false;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: { 'おまかせギフトラッピング': '', 'Gift Wrap Count': '0' }
          })
        })
        .then(() => {
          window.cartAttributeUpdateCompleted = true;
          console.log('Cart attribute update completed (fallback), flag set to true');
        })
        .catch(error => {
          console.error('Error clearing cart attributes:', error);
          // エラー時もフラグを設定
          window.cartAttributeUpdateCompleted = true;
        });
    }

      // 注意: ローディングスピナーの非表示はupdateQuantity内で行うため、ここでは行わない
      // updateQuantity内で、renderContents完了後にローディングスピナーを非表示にする
      // isUpdatingフラグのリセットもupdateQuantity内で行う
    }

    // DOM更新後、カスタム要素が確実に動作するようにする
    // カスタム要素は自動的に再初期化されるが、念のため確認
    // 注意: ローディングの非表示はupdateQuantity内で行うため、ここでは行わない
    // ただし、残っている状態をクリーンアップする
    // renderContents完了時点では、まだupdateQuantity内でローディングを非表示にする処理が実行される前
    // そのため、ここではクリーンアップのみ行う

    // renderContents完了をログ出力
    // 注意: renderContents内の非同期処理（setTimeout内のfetchなど）は完了を待たない
    // これらの処理はバックグラウンドで実行され、完了を待たない
    // ローディングの非表示はupdateQuantity内で行う
    console.log('renderContents finished, line:', loadingLine);

    // 非同期処理が完了するまで少し待機（DOM更新後の処理を確実にする）
    // ただし、これは必須ではない（updateQuantity内でさらに待機するため）
    await new Promise(resolve => setTimeout(resolve, 100));
  }

  async checkAndRemoveGiftWrappingOnly() {
    const functionStartTime = Date.now();
    console.log('[checkAndRemoveGiftWrappingOnly] Function started');

    // 既にロックが取得されている場合は、executeWithLockをスキップ
    const isAlreadyLocked = window.cartUpdateQueue && window.cartUpdateQueue.isLocked;
    if (isAlreadyLocked) {
      console.log('[checkAndRemoveGiftWrappingOnly] Already locked, skipping executeWithLock');
      return this._checkAndRemoveGiftWrappingOnlyInternal(functionStartTime);
    }

    return window.cartUpdateQueue.executeWithLock(async () => {
      const lockStartTime = Date.now();
      console.log('[checkAndRemoveGiftWrappingOnly] Lock acquired, elapsed:', lockStartTime - functionStartTime, 'ms');
      return this._checkAndRemoveGiftWrappingOnlyInternal(functionStartTime);
    });
  }

  async _checkAndRemoveGiftWrappingOnlyInternal(functionStartTime) {
    try {
      // renderContentsで取得済みのcartDataを再利用（過剰なAPI呼び出しを防ぐ）
      // cartItems要素からlastCartDataを取得
      const cartDataFetchStartTime = Date.now();
      const cartItemsElement = document.querySelector('cart-items');
      let cartData = null;

      if (cartItemsElement && cartItemsElement.lastCartData) {
        cartData = cartItemsElement.lastCartData;
        console.log('[checkAndRemoveGiftWrappingOnly] Reusing cartData from renderContents, elapsed:', Date.now() - cartDataFetchStartTime, 'ms');
      } else {
        // データがない場合のみ新規取得（フォールバック）
        console.log('[checkAndRemoveGiftWrappingOnly] No cached cartData available, fetching from API (fallback)');
        const response = await fetch('/cart.js');
        cartData = await response.json();
        console.log('[checkAndRemoveGiftWrappingOnly] CartData fetched from API, elapsed:', Date.now() - cartDataFetchStartTime, 'ms');
      }

      if (!cartData || !cartData.items) {
        console.warn('Cart data not available, skipping check');
        return;
      }

      // Gift Wrapping商品のバリアントIDを取得（Liquidから埋め込まれた値を使用）
      const giftVariantId = window.giftWrappingVariantId;
      if (!giftVariantId) return;

      // 通常商品（非売品以外）があるかチェック
      const checkStartTime = Date.now();
      const hasNormalItems = cartData.items.some(item => {
        return item.product_type !== '非売品' && item.variant_id !== giftVariantId;
      });

      // Gift Wrapping商品があるかチェック
      const giftWrapItem = cartData.items.find(item => item.variant_id === giftVariantId);

      console.log('[checkAndRemoveGiftWrappingOnly] Check completed, hasNormalItems:', hasNormalItems, 'giftWrapItem:', !!giftWrapItem, 'elapsed:', Date.now() - checkStartTime, 'ms');

      // 通常商品がなく、Gift Wrapping商品だけが残っている場合
      if (!hasNormalItems && giftWrapItem) {
        console.log('[checkAndRemoveGiftWrappingOnly] Only gift wrapping item remains, removing it...');

        // Gift Wrapping商品を削除（409エラー時はリトライ）
        const removeStartTime = Date.now();
        let retryCount = 0;
        while (retryCount < 3) {
          try {
            const response = await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: giftWrapItem.key, quantity: 0 })
            });

            if (response.ok) {
              console.log('[checkAndRemoveGiftWrappingOnly] Gift wrap item removed successfully, elapsed:', Date.now() - removeStartTime, 'ms');
              break; // 成功
            } else if (response.status === 409 && retryCount < 2) {
              console.info(`[checkAndRemoveGiftWrappingOnly] ⏱️ Cart conflict detected, auto-retrying... (attempt ${retryCount + 1}/3)`);
              await new Promise(resolve => setTimeout(resolve, 500 * (retryCount + 1)));
              retryCount++;
            } else {
              console.error('[checkAndRemoveGiftWrappingOnly] Failed to remove gift wrap item:', response.status);
              break;
            }
          } catch (error) {
            console.error('[checkAndRemoveGiftWrappingOnly] Error removing gift wrap item:', error);
            break;
          }
        }

        // UIを更新（.cart-wrapping要素全体を非表示にする）
        const omakaseRadio = document.getElementById('omakase');
        const noneRadio = document.getElementById('none');
        const cartWrapping = document.querySelector('.cart-wrapping');
        const cartWrappingItem = document.querySelector('.cart-wrapping-item');
        const wrappingDetail = document.querySelector('.cart-wrapping-detail');
        const wrappingOptions = document.querySelectorAll('.wrapping-options');

        if (noneRadio) noneRadio.checked = true;
        if (omakaseRadio) omakaseRadio.checked = false;
        // .cart-wrapping要素全体を非表示にする（これが最も重要）
        if (cartWrapping) cartWrapping.style.display = 'none';
        if (cartWrappingItem) cartWrappingItem.style.display = 'none';
        if (wrappingDetail) wrappingDetail.style.display = 'none';
        wrappingOptions.forEach(opt => opt.style.display = 'none');

        // 少し待機してからページをリロード
        await new Promise(resolve => setTimeout(resolve, 300));

        // ページをリロードして完全に空の状態を表示
        console.log('[checkAndRemoveGiftWrappingOnly] Reloading page, total elapsed:', Date.now() - functionStartTime, 'ms');
        window.location.reload();
      } else {
        console.log('[checkAndRemoveGiftWrappingOnly] No action needed (hasNormalItems:', hasNormalItems, 'giftWrapItem:', !!giftWrapItem, '), total elapsed:', Date.now() - functionStartTime, 'ms');
      }
    } catch (error) {
      console.error('[checkAndRemoveGiftWrappingOnly] Error checking gift wrapping only:', error, 'total elapsed:', Date.now() - functionStartTime, 'ms');
      // エラーが発生してもページリロードするため、ローディングは保持
    }
  }

  async checkAndHideGiftWrappingUI() {
    const functionStartTime = Date.now();
    console.log('[checkAndHideGiftWrappingUI] Function started');

    // 既にロックが取得されている場合は、executeWithLockをスキップ
    const isAlreadyLocked = window.cartUpdateQueue && window.cartUpdateQueue.isLocked;
    if (isAlreadyLocked) {
      console.log('[checkAndHideGiftWrappingUI] Already locked, skipping executeWithLock');
      return this._checkAndHideGiftWrappingUIInternal(functionStartTime);
    }

    return window.cartUpdateQueue.executeWithLock(async () => {
      const lockStartTime = Date.now();
      console.log('[checkAndHideGiftWrappingUI] Lock acquired, elapsed:', lockStartTime - functionStartTime, 'ms');
      return this._checkAndHideGiftWrappingUIInternal(functionStartTime);
    });
  }

  async _checkAndHideGiftWrappingUIInternal(functionStartTime) {
    try {
        // renderContentsで取得済みのcartDataを再利用（過剰なAPI呼び出しを防ぐ）
        // cartItems要素からlastCartDataを取得
        const cartDataFetchStartTime = Date.now();
        const cartItemsElement = document.querySelector('cart-items');
        let cartData = null;

        if (cartItemsElement && cartItemsElement.lastCartData) {
          cartData = cartItemsElement.lastCartData;
          console.log('[checkAndHideGiftWrappingUI] Reusing cartData from renderContents, elapsed:', Date.now() - cartDataFetchStartTime, 'ms');
        } else {
          // データがない場合のみ新規取得（フォールバック）
          console.log('[checkAndHideGiftWrappingUI] No cached cartData available, fetching from API (fallback)');
          const response = await fetch('/cart.js');
          cartData = await response.json();
          console.log('[checkAndHideGiftWrappingUI] CartData fetched from API, elapsed:', Date.now() - cartDataFetchStartTime, 'ms');
        }

        // Gift Wrapping商品のバリアントIDを取得
        const giftVariantId = window.giftWrappingVariantId;
        if (!giftVariantId) return;

        // Gift Wrapping商品と非売品を除外した商品をチェック
        const normalItemsCheckStartTime = Date.now();
        const normalItems = cartData.items.filter(item => {
          return item.product_type !== '非売品' && item.variant_id !== giftVariantId;
        });

        console.log('[checkAndHideGiftWrappingUI] Normal items in cart:', normalItems.length, 'elapsed:', Date.now() - normalItemsCheckStartTime, 'ms');

        if (normalItems.length === 0) {
          // 通常商品がない場合（カートが空またはGift Wrapping商品のみの場合）
          // Gift WrappingのUIを非表示にする
          console.log('[checkAndHideGiftWrappingUI] No normal items, hiding gift wrapping UI...');

          const omakaseRadio = document.getElementById('omakase');
          const noneRadio = document.getElementById('none');
          const cartWrapping = document.querySelector('.cart-wrapping');
          const cartWrappingItem = document.querySelector('.cart-wrapping-item');
          const wrappingDetail = document.querySelector('.cart-wrapping-detail');
          const wrappingOptions = document.querySelectorAll('.wrapping-options');

          if (omakaseRadio) omakaseRadio.checked = false;
          if (noneRadio) noneRadio.checked = true;
          if (cartWrapping) cartWrapping.style.display = 'none';
          if (cartWrappingItem) cartWrappingItem.style.display = 'none';
          if (wrappingDetail) wrappingDetail.style.display = 'none';
          wrappingOptions.forEach(opt => opt.style.display = 'none');

          // カート属性をクリア
          const attributesClearStartTime = Date.now();
          try {
            // updateCartAttributes関数を使用（リトライロジック付き）
            if (window.updateCartAttributes) {
              await window.updateCartAttributes({ 'おまかせギフトラッピング': '', 'Gift Wrap Count': '0', 'Gift_Wrapping_Selections': '' });
              console.log('[checkAndHideGiftWrappingUI] Cart attributes cleared, elapsed:', Date.now() - attributesClearStartTime, 'ms');
            } else {
              // フォールバック: 直接fetch（リトライなし）
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                attributes: { 'おまかせギフトラッピング': '', 'Gift Wrap Count': '0', 'Gift_Wrapping_Selections': '' }
              })
            });
            console.log('[checkAndHideGiftWrappingUI] Cart attributes cleared, elapsed:', Date.now() - attributesClearStartTime, 'ms');
            }
          } catch (error) {
            console.error('[checkAndHideGiftWrappingUI] Error clearing cart attributes:', error, 'elapsed:', Date.now() - attributesClearStartTime, 'ms');
          }

          console.log('[checkAndHideGiftWrappingUI] Function completed (no normal items), total elapsed:', Date.now() - functionStartTime, 'ms');
          return;
        }

        // 全ての通常商品がwrappingNGFlag = 1かチェック
        const wrappingNGFlagCheckStartTime = Date.now();
        const allItemsAreNGFlag = normalItems.every(item => {
          // DOM内の該当商品のメタフィールドを取得
          const cartItem = document.querySelector(`[data-index="${item.key}"]`);
          if (!cartItem) return false;

          const wrappingFlag = cartItem.getAttribute('data-wrapping-ng-flag');
          console.log('[checkAndHideGiftWrappingUI] Item:', item.product_title, 'wrappingNGFlag:', wrappingFlag);

          return wrappingFlag === '1';
        });

        console.log('[checkAndHideGiftWrappingUI] All items are wrappingNGFlag:', allItemsAreNGFlag, 'elapsed:', Date.now() - wrappingNGFlagCheckStartTime, 'ms');

        // 全ての商品がwrappingNGFlag = 1の場合、ギフトラッピングUIを非表示
        if (allItemsAreNGFlag) {
          const ngFlagProcessingStartTime = Date.now();
          console.log('[checkAndHideGiftWrappingUI] All items have wrappingNGFlag = 1, hiding gift wrapping UI and removing gift wrap item');

          // Gift Wrapping商品がカートにあるかチェック
          const giftWrapItem = cartData.items.find(item => item.variant_id === giftVariantId);

          if (giftWrapItem) {
          // ギフトラッピング商品を削除することを示すフラグを設定（updateQuantity内の合計金額更新待機をスキップするため）
          window.giftWrappingItemWillBeRemoved = true;
          // 合計金額更新待機完了フラグを初期化
          window.giftWrappingTotalUpdateCompleted = false;
          // UIを先に非表示にする（即座に実行）
          const uiHideStartTime = Date.now();
          console.log('[checkAndHideGiftWrappingUI] Hiding gift wrapping UI immediately...');
          const omakaseRadio = document.getElementById('omakase');
          const noneRadio = document.getElementById('none');
          const cartWrapping = document.querySelector('.cart-wrapping');
          const cartWrappingItem = document.querySelector('.cart-wrapping-item');
          const wrappingDetail = document.querySelector('.cart-wrapping-detail');
          const wrappingOptions = document.querySelectorAll('.wrapping-options');

          if (omakaseRadio) omakaseRadio.checked = false;
          if (noneRadio) noneRadio.checked = true;
          if (cartWrapping) cartWrapping.style.display = 'none';
          if (cartWrappingItem) cartWrappingItem.style.display = 'none';
          if (wrappingDetail) wrappingDetail.style.display = 'none';
          wrappingOptions.forEach(opt => opt.style.display = 'none');
          console.log('[checkAndHideGiftWrappingUI] Gift wrapping UI hidden immediately, elapsed:', Date.now() - uiHideStartTime, 'ms');

          // カート属性をリセット（ラジオボタン処理フローと同様、UI非表示の直後に実行）
          const attributesResetStartTime = Date.now();
          console.log('[checkAndHideGiftWrappingUI] Resetting cart attributes...');
          try {
            // updateCartAttributes関数を使用（リトライロジック付き）
            if (window.updateCartAttributes) {
              await window.updateCartAttributes({ 'おまかせギフトラッピング': '', 'Gift_Wrapping_Selections': '' });
              console.log('[checkAndHideGiftWrappingUI] Cart attributes reset successfully, elapsed:', Date.now() - attributesResetStartTime, 'ms');
            } else {
              // フォールバック: 直接fetch（リトライなし）
              const response = await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  attributes: { 'おまかせギフトラッピング': '', 'Gift_Wrapping_Selections': '' }
                })
              });
              if (response.ok) {
                console.log('[checkAndHideGiftWrappingUI] Cart attributes reset successfully, elapsed:', Date.now() - attributesResetStartTime, 'ms');
              }
            }
          } catch (error) {
            console.error('[checkAndHideGiftWrappingUI] Error resetting cart attributes:', error, 'elapsed:', Date.now() - attributesResetStartTime, 'ms');
            // エラーが発生しても処理を続行
          }

          // カートAPIから削除前の合計金額を取得（削除後の期待値を計算するため）
          const priceCheckStartTime = Date.now();
          let currentTotalPrice = null;
          let giftWrapItemPrice = null;
          try {
            const currentCartData = await fetch('/cart.js').then(r => {
              if (!r.ok) throw new Error(`HTTP error! status: ${r.status}`);
              return r.json();
            });
            currentTotalPrice = currentCartData ? currentCartData.total_price : null;
            // ギフトラッピング商品の価格を取得
            if (giftWrapItem && giftWrapItem.final_price) {
              giftWrapItemPrice = giftWrapItem.final_price * giftWrapItem.quantity;
            }
            console.log('[checkAndHideGiftWrappingUI] Current total price before gift wrap removal:', currentTotalPrice, 'Gift wrap item price:', giftWrapItemPrice, 'elapsed:', Date.now() - priceCheckStartTime, 'ms');
          } catch (error) {
            console.warn('[checkAndHideGiftWrappingUI] Failed to fetch cart data for price check:', error, 'elapsed:', Date.now() - priceCheckStartTime, 'ms');
          }

          // ギフトラッピング商品削除を実行（完了を待つ必要がある）
          const removeStartTime = Date.now();
          console.log('[checkAndHideGiftWrappingUI] Removing gift wrap item from cart...');
          let removeGiftWrapSuccess = false;
          let retryCount = 0;
          while (retryCount < 3) {
            try {
              const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: giftWrapItem.key, quantity: 0 })
              });

              if (response.ok) {
                console.log('[checkAndHideGiftWrappingUI] Gift wrap item removed successfully, elapsed:', Date.now() - removeStartTime, 'ms');
                removeGiftWrapSuccess = true;
                break; // 成功
              } else if (response.status === 409 && retryCount < 2) {
                console.info(`[checkAndHideGiftWrappingUI] ⏱️ Cart conflict detected, auto-retrying... (attempt ${retryCount + 1}/3)`);
                await new Promise(resolve => setTimeout(resolve, 500 * (retryCount + 1)));
                retryCount++;
              } else {
                console.error('[checkAndHideGiftWrappingUI] Failed to remove gift wrap item:', response.status, 'elapsed:', Date.now() - removeStartTime, 'ms');
                break;
              }
            } catch (error) {
              console.error('[checkAndHideGiftWrappingUI] Error removing gift wrap item:', error, 'elapsed:', Date.now() - removeStartTime, 'ms');
              break;
            }
          }

          // 合計金額更新待機（フラグベース、ギフトラッピング商品削除後の合計金額を待つ）
          const totalUpdateWaitStartTime = Date.now();
          console.log('[checkAndHideGiftWrappingUI] Waiting for cart total to update after gift wrap removal...');

          // カートAPIから最新の合計金額を取得（ギフトラッピング商品削除後の期待値を計算）
          let expectedTotalPrice = null;
          try {
            const latestCartData = await fetch('/cart.js').then(r => {
              if (!r.ok) throw new Error(`HTTP error! status: ${r.status}`);
              return r.json();
            });
            expectedTotalPrice = latestCartData ? latestCartData.total_price : null;
            console.log('[checkAndHideGiftWrappingUI] Expected total price after gift wrap removal:', expectedTotalPrice, 'elapsed:', Date.now() - totalUpdateWaitStartTime, 'ms');
          } catch (error) {
            console.warn('[checkAndHideGiftWrappingUI] Failed to fetch cart data for price check:', error, 'elapsed:', Date.now() - totalUpdateWaitStartTime, 'ms');
            // エラー時は現在の合計金額からギフトラッピング商品の価格を引いて期待値を計算
            if (currentTotalPrice !== null && giftWrapItemPrice !== null) {
              expectedTotalPrice = currentTotalPrice - giftWrapItemPrice;
              console.log('[checkAndHideGiftWrappingUI] Calculated expected total price from current total:', expectedTotalPrice);
            }
          }

          // カートフッターの合計金額が更新されるまで待機（フラグベース、ラジオボタン処理フローと同じ方法）
          if (expectedTotalPrice !== null) {
            const cartFooter = document.getElementById('main-cart-footer');
            if (cartFooter) {
              const startTime = Date.now();
              const timeout = 2000; // タイムアウト: 2秒（ラジオボタン処理フローと同じ）
              const pollInterval = 50; // ポーリング間隔: 50ms（より頻繁にチェック）

              let isUpdated = false;

              // フラグが立つか、タイムアウトするまで待機
              while (!isUpdated && (Date.now() - startTime) < timeout) {
                // フラグをチェック
                if (window.cartTotalUpdated) {
                  console.log('[checkAndHideGiftWrappingUI] Cart footer total updated flag detected');

                  // フラグが立った場合、実際の合計金額が期待値と一致するか確認
                  const totalPriceElement = cartFooter.querySelector('.cart__totals .cart__total-price');
                  if (totalPriceElement) {
                    const currentTotalText = totalPriceElement.textContent || '';
                    const currentTotalValue = parseFloat(currentTotalText.replace(/[^\d.]/g, '')) * 100; // セント単位に変換

                    // 期待値と一致するか確認（±1セントの誤差を許容）
                    if (Math.abs(currentTotalValue - expectedTotalPrice) <= 1) {
                      console.log('[checkAndHideGiftWrappingUI] Cart footer total updated and matches expected value:', expectedTotalPrice, 'polling elapsed:', Date.now() - startTime, 'ms');
                      isUpdated = true;
                      break;
                    }
                  }
                }

                // フラグが立っていない場合、直接DOMをチェック（フォールバック）
                const totalPriceElement = cartFooter.querySelector('.cart__totals .cart__total-price');
                if (totalPriceElement) {
                  const currentTotalText = totalPriceElement.textContent || '';
                  const currentTotalValue = parseFloat(currentTotalText.replace(/[^\d.]/g, '')) * 100; // セント単位に変換

                  // 期待値と一致するか確認（±1セントの誤差を許容）
                  if (Math.abs(currentTotalValue - expectedTotalPrice) <= 1) {
                    console.log('[checkAndHideGiftWrappingUI] Cart footer total updated and matches expected value (direct check):', expectedTotalPrice, 'polling elapsed:', Date.now() - startTime, 'ms');
                    isUpdated = true;
                    break;
                  }
                }

                // ポーリング間隔待機
                await new Promise(resolve => setTimeout(resolve, pollInterval));
              }

              if (!isUpdated) {
                const elapsedTime = Date.now() - startTime;
                console.log(`[checkAndHideGiftWrappingUI] Cart footer total update timeout after ${elapsedTime}ms, proceeding anyway (this is normal if update is slow)`);
              } else {
                const elapsedTime = Date.now() - startTime;
                console.log(`[checkAndHideGiftWrappingUI] Cart footer total updated successfully after ${elapsedTime}ms`);
              }

              // フラグをリセット
              window.cartTotalUpdated = false;
            } else {
              // カートフッター要素が見つからない場合、短い待機
              await new Promise(resolve => setTimeout(resolve, 300));
            }
          } else {
            // カートAPIから合計金額を取得できなかった場合、短い待機
            await new Promise(resolve => setTimeout(resolve, 300));
          }

          // 合計金額更新待機が完了したことを示すフラグを設定（updateQuantity内でLoading spinnerを非表示にする前に待機するため）
          window.giftWrappingTotalUpdateCompleted = true;
          console.log('[checkAndHideGiftWrappingUI] Gift wrapping total update completed flag set to true, total elapsed:', Date.now() - ngFlagProcessingStartTime, 'ms');

          // ギフトラッピング商品削除完了フラグをリセット
          window.giftWrappingItemWillBeRemoved = false;

          // カート属性リセットはUI非表示の直後に実行済み（ラジオボタン処理フローと同様）

          // さらに待機してカート更新を確実にする
          await new Promise(resolve => setTimeout(resolve, 300));

          // カート情報を再取得してDOMを更新（カートアイコンも含める）
          // 401エラーを防ぐため、エラーハンドリングを追加
          try {
            const sectionsToFetch = this.getSectionsToRender().map(s => s.section).join(',');
            const updatedCartResponse = await fetch(
              `${window.location.pathname}?sections=${sectionsToFetch}`
            );

            if (!updatedCartResponse.ok) {
              console.warn(`Failed to fetch sections: ${updatedCartResponse.status} ${updatedCartResponse.statusText}`);
              // 401エラーの場合、セクション更新をスキップして続行
              if (updatedCartResponse.status === 401) {
                console.warn('Unauthorized error when fetching sections, skipping section update');
                return;
              }
              throw new Error(`HTTP error! status: ${updatedCartResponse.status}`);
            }

            const updatedSections = await updatedCartResponse.json();

            console.log('Updated sections received:', updatedSections);

            // セクションを更新
            this.getSectionsToRender().forEach((section) => {
              const sectionElement = document.getElementById(section.id);
              if (sectionElement && updatedSections[section.section]) {
                const targetElement = sectionElement.querySelector(section.selector);
                if (targetElement) {
                  targetElement.innerHTML = this.getSectionInnerHTML(updatedSections[section.section], section.selector);
                  console.log(`Updated section ${section.id} DOM`);
                }
              }
            });
          } catch (error) {
            console.error('Error fetching/updating sections:', error);
            // エラーが発生しても処理を続行（カートフッターの更新は別途行われる）
          }

          // 最新のカート情報を取得してカートアイコンのバッジを更新
          const latestCartData = await fetch('/cart.js').then(r => r.json());
          // ギフトラッピング商品を除外したカート商品数を計算
          const giftVariantIdForCount = window.giftWrappingVariantId;
          let itemCountExcludingGiftWrappingForCount = latestCartData.item_count || 0;
          if (giftVariantIdForCount && latestCartData.items) {
            itemCountExcludingGiftWrappingForCount = latestCartData.items.reduce((count, item) => {
              if (item.variant_id !== giftVariantIdForCount) {
                return count + (item.quantity || 0);
              }
              return count;
            }, 0);
          }

          // カートが空になった場合、main-cart-footerを非表示にする
          if (itemCountExcludingGiftWrappingForCount === 0) {
            const cartFooter = document.getElementById('main-cart-footer');
            if (cartFooter) {
              cartFooter.classList.add('is-empty');
              console.log('Cart footer set to is-empty (cart is empty after gift wrap removal)');
            }

            // bodyタグのクラスも更新
            document.body.classList.remove('cart-has-items');
            document.body.classList.add('cart-empty');
          }

          // カートアイコンのカウントを更新（カートが空の場合は非表示）
          const cartIconBubbles = document.querySelectorAll('.cart-count-bubble');
          cartIconBubbles.forEach(bubble => {
            if (itemCountExcludingGiftWrappingForCount > 0) {
              const bubbleSpan = bubble.querySelector('span');
              if (bubbleSpan) {
                bubbleSpan.textContent = itemCountExcludingGiftWrappingForCount;
              }
              bubble.style.display = '';
            } else {
              bubble.style.display = 'none';
            }
          });
          console.log('Cart icon bubbles manually updated to (excluding gift wrapping):', itemCountExcludingGiftWrappingForCount, 'original:', latestCartData.item_count);

          console.log('Gift wrapping UI hidden and item removed');
          }
        } else {
          console.log('[checkAndHideGiftWrappingUI] Not all items have wrappingNGFlag = 1, no action needed, total elapsed:', Date.now() - functionStartTime, 'ms');
        }

        console.log('[checkAndHideGiftWrappingUI] Function completed, total elapsed:', Date.now() - functionStartTime, 'ms');
    } catch (error) {
      console.error('[checkAndHideGiftWrappingUI] Error in internal function:', error, 'total elapsed:', Date.now() - functionStartTime, 'ms');
    }
  }

  updateLiveRegions(line, message) {
    // lineはitem.index（1ベースの数値）を使用
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);

    if (lineItemError) {
      const errorText = lineItemError.querySelector('.cart-item__error-text');
      if (errorText) errorText.textContent = message;
    }

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (cartStatus) {
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    console.log('enableLoading called for line:', line);
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
    mainCartItems.classList.add('cart__items--disabled');
      console.log('Added cart__items--disabled class to mainCartItems');
    }

    // lineはitem.index（1ベースの数値）を使用
    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    console.log('Found loading spinners - CartItem:', cartItemElements.length, 'CartDrawer-Item:', cartDrawerItemElements.length);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => {
      overlay.classList.remove('hidden');
      console.log('Showed loading spinner for line:', line);
    });

    document.activeElement.blur();
    if (this.lineItemStatusElement) {
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading(line) {
    console.log('disableLoading called for line:', line);

    // まず、cart__items--disabledクラスを削除（これが最も重要）
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
    mainCartItems.classList.remove('cart__items--disabled');
      console.log('Removed cart__items--disabled class from mainCartItems');
    }

    // すべてのローディングスピナーを非表示にする関数
    const hideAllSpinners = () => {
      // document全体でローディングスピナーを探す（DOM更新後の新しい要素も含む）
      const allSpinners = document.querySelectorAll('.loading__spinner');
      allSpinners.forEach((overlay) => {
        overlay.classList.add('hidden');
        overlay.style.display = 'none';
        overlay.setAttribute('aria-hidden', 'true');
      });
      console.log(`Hidden all ${allSpinners.length} loading spinners globally`);

      // 特定のlineのローディングスピナーも非表示にする（念のため）
      if (line) {
        const cartItemElements = document.querySelectorAll(`#CartItem-${line} .loading__spinner`);
        const cartDrawerItemElements = document.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
        [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => {
          overlay.classList.add('hidden');
          overlay.style.display = 'none';
          overlay.setAttribute('aria-hidden', 'true');
        });
        console.log(`Hidden loading spinners for line ${line}: CartItem=${cartItemElements.length}, CartDrawer=${cartDrawerItemElements.length}`);
      }
    };

    // 即座に実行
    hideAllSpinners();

    // DOM更新後、要素が再作成される可能性があるため、少し待ってから再実行
    setTimeout(hideAllSpinners, 50);
    setTimeout(hideAllSpinners, 150);
  }

  // "Your Cart"の右隣のカウントを更新する関数
  updatePageHeadingCartCount(itemCount) {
    const pageHeadingTitle = document.querySelector('.custom-page-heading .title');
    if (pageHeadingTitle) {
      let cartCountContainer = pageHeadingTitle.querySelector('.cart-count-container');
      if (!cartCountContainer) {
        // cart-count-container要素が存在しない場合は作成
        cartCountContainer = document.createElement('div');
        cartCountContainer.className = 'cart-count-container';

        const cartCountSpan = document.createElement('span');
        cartCountSpan.className = 'cart-count';
        cartCountSpan.id = 'cart-count';

        const itemsSpan = document.createElement('span');
        itemsSpan.className = 'cart-items-text';
        itemsSpan.textContent = ' items';

        cartCountContainer.appendChild(cartCountSpan);
        cartCountContainer.appendChild(itemsSpan);
        pageHeadingTitle.appendChild(cartCountContainer);
      }

      const cartCountSpan = cartCountContainer.querySelector('.cart-count');
      if (cartCountSpan) {
        cartCountSpan.textContent = itemCount;
        console.log('Page heading cart count updated to (excluding gift wrapping):', itemCount);
      } else {
        console.warn('cart-count span not found in cart-count-container');
      }
    } else {
      console.warn('Page heading title not found');
    }
  }

}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
